{
  "Actions": {
    "actions": "Aktionen",
    "back": "Zurück",
    "click here": "Hier klicken",
    "collapse": "Zusammenklappen",
    "expand": "Erweitern",
    "go to vehicle": "Zum Fahrzeug"
  },
  "Alert": {
    "Account is already activated": "Das Konto wurde bereits aktiviert",
    "action failed": "Aktion aufgrund eines Fehlers fehlgeschlagen",
    "add company card success": "Neue Firmenkarte erfolgreich hinzugefügt.",
    "add driver success": "Fahrer erfolgreich hinzugefügt",
    "add integration success": "Integration erfolgreich erstellt.",
    "add vehicle empty imei info": {
      "description": "Dem Fahrzeug ist keine IMEI zugewiesen, daher können keine Dateien heruntergeladen werden. Fügen Sie eine gültige IMEI hinzu, um Fahrzeugdateien herunterzuladen.",
      "title": "Fahrzeug erfolgreich hinzugefügt, aber keine IMEI zugewiesen."
    },
    "add vehicle success": "Fahrzeug erfolgreich hinzugefügt",
    "An unhandled error occured while processing this request": "Bei der Bearbeitung dieser Anfrage ist ein unerwarteter Fehler aufgetreten.",
    "Another driver is registered under this card number.": "Unter dieser Kartennummer ist ein weiterer Fahrer registriert.",
    "apply all driver schedules success": "Der Zeitplan wurde erfolgreich für alle Fahrer hinzugefügt.",
    "apply all vehicle schedules success": "Zeitplan erfolgreich zu allen Fahrzeugen hinzugefügt.",
    "apply driver schedules success": "Der Zeitplan wurde erfolgreich für {{resourceCount}} Fahrer hinzugefügt.",
    "apply vehicle schedules success": "Der Zeitplan wurde erfolgreich zu {{resourceCount}} Fahrzeugen hinzugefügt.",
    "cancel invitation success": "Einladung erfolgreich storniert.",
    "Card number must be 16 characters in length.": "Die Fahrer-ID muss 16 Zeichen lang sein.",
    "CCA file download success": "Der Company Card Authenticator wurde erfolgreich heruntergeladen.",
    "Comment must not be longer than 255 characters.": "Die zulässige Zeichenanzahl für die Beschreibung beträgt 255.",
    "Company card with such ID already exists.": "Eine Firmenkarte mit dieser ID existiert bereits.",
    "Company card with such name already exists.": "Es gibt bereits eine Firmenkarte mit diesem Namen.",
    "Company not found": "Unternehmen nicht gefunden.",
    "Company not found.": "Unternehmen nicht gefunden.",
    "Company with this LZ client code already exists.": "Ein Unternehmen mit diesem Teltonika-Code existiert bereits.",
    "create client company success": "Neues Kundenunternehmen erfolgreich angelegt.",
    "create company success": "Unternehmen erfolgreich erstellt.",
    "create schedule success": "Neuer Zeitplan erfolgreich erstellt.",
    "credits overdraft activated": "Kreditüberziehung erfolgreich aktiviert",
    "credits overdraft deactivated": "Kontoüberziehung erfolgreich deaktiviert",
    "disable integration success": "Integration erfolgreich deaktiviert.",
    "Driver duplication.": "Fahrer Duplikat.",
    "Driver name contains invalid characters.": "Der Name des Fahrers enthält ungültige Zeichen.",
    "Driver name must be 3-50 characters long.": "Der Name des Fahrers muss zwischen 3 und 50 Zeichen lang sein.",
    "Driver with such card number already exists.": "Die Fahrer-ID existiert bereits.",
    "Drivers schedules were not found": "Es wurden keine Fahrpläne gefunden.",
    "edit company card success": "Firmenkarte erfolgreich bearbeitet.",
    "edit integration success": "Integration erfolgreich bearbeitet.",
    "edit schedule success": "Zeitplan erfolgreich bearbeitet.",
    "edit user description": "Die Änderungen werden nach der nächsten Abmeldung des Benutzers übernommen.",
    "Email recipient was not found.": "Der E-Mail-Empfänger wurde nicht gefunden.",
    "email transfer edit recipient success": "Der E-Mail-Empfänger wurde erfolgreich bearbeitet.",
    "email transfer new recipient success": "Der E-Mail-Empfänger wurde erfolgreich hinzugefügt.",
    "email transfer remove recipient success": "Der E-Mail-Empfänger wurde erfolgreich entfernt.",
    "enable integration success": "Integration erfolgreich aktiviert.",
    "error": {
      "import failed": "Der Import der Datei ist fehlgeschlagen. Löschen Sie die Datei, stellen Sie sicher, dass die Daten der erforderlichen Struktur entsprechen, und laden Sie die Datei erneut hoch.",
      "import failed description": "Löschen Sie die Datei, stellen Sie sicher, dass die Daten der erforderlichen Struktur entsprechen, und laden Sie die Datei erneut hoch.",
      "import failed title": "Import fehlgeschlagen. Die Daten stimmen nicht mit der vorgegebenen Dateistruktur überein."
    },
    "general settings update success": "Einstellungen erfolgreich geändert.",
    "global schedule success": "Globaler Zeitplan erfolgreich erstellt.",
    "Id must be of digits and letters only": "Die ID darf nur aus Ziffern und Buchstaben bestehen",
    "Id must be of length 6 to 8": "Die ID muss eine Länge von 6 bis 8 Zeichen haben",
    "Imei must be 15 characters long.": "Die IMEI muss 15 Zeichen lang sein.",
    "Imei must be numeric.": "Für das IMEI-Feld sind nur numerische Werte zulässig.",
    "integration editing cancelled": "Bearbeitung der Integration abgebrochen.",
    "Integration is disabled. Enable it first before retrying": "Die Integration ist deaktiviert. Aktivieren Sie sie zunächst, bevor Sie es erneut versuchen.",
    "Invalid email address": "Ungültige E-Mail-Adresse.",
    "Invalid format.": "Ungültiges Dateiformat",
    "LZ client code not found.": "Teltonika-Code nicht gefunden.",
    "move company success": "Das Unternehmen „{{sourceCompany}}“ wurde erfolgreich zu „{{targetCompany}}“ verlegt.",
    "New name must be different from the current name.": "Der neue Name muss sich vom aktuellen Namen unterscheiden.",
    "news created": "Der Beitrag wurde erfolgreich erstellt.",
    "news deleted": "Der Beitrag wurde erfolgreich gelöscht.",
    "news edited": "Der Beitrag wurde erfolgreich bearbeitet.",
    "news published": "Der Beitrag wurde erfolgreich veröffentlicht.",
    "Number must be provided.": "Die Nummer muss angegeben werden.",
    "Number must not be longer than 30 characters.": "Die zulässige Zeichenanzahl für das Kennzeichen beträgt 30.",
    "One or more selected companies have child companies and cannot be deleted.": "Ein oder mehrere ausgewählte Unternehmen haben Tochterunternehmen und können nicht gelöscht werden.",
    "One or more validation errors occured while parsing csv file. Please use template file for reference.": "Beim Parsen der CSV-Datei sind ein oder mehrere Validierungsfehler aufgetreten. Bitte verwenden Sie die Vorlagendatei als Referenz",
    "One or more validation errors occured.": "Es sind ein oder mehrere Validierungsfehler aufgetreten.",
    "quick schedule created": {
      "description": {
        "drivers": "Der Daten-Download wird gestartet, sobald die Verbindung des Fahrers zu TachoSync erkannt wird.",
        "vehicles": "Der Daten-Download wird gestartet, sobald die Verbindung des Fahrzeugs zu TachoSync erkannt wird."
      },
      "title": "Schnellplan erfolgreich erstellt.",
      "title multiple drivers": "Schnellplan für {{driverNum}} Fahrer erfolgreich erstellt.",
      "title multiple vehicles": "Schnellplan für {{vehicleNum}} Fahrzeuge erfolgreich erstellt.",
      "title single driver": "Schnellplan erfolgreich erstellt."
    },
    "Quick schedule for vehicle is already created.": "Diesem Fahrzeug ist bereits ein Zeitplan zugewiesen.",
    "Quick schedule is already assigned to the driver.": "Dem Fahrer wurde bereits ein Schnellplan zugewiesen.",
    "remove company card success": "Firmenkarte erfolgreich entfernt.",
    "resend invitation success": "Die Einladung wurde erfolgreich erneut gesendet.",
    "retry integration success": "Die Integration „{{integrationName}}“ wurde erfolgreich verbunden.",
    "retry interrupted integration success": "Die Integration „{{integrationName}}“ versucht erneut, die übersprungenen Dateien zu synchronisieren. Bitte versuchen Sie es später erneut, um den Status zu überprüfen.",
    "session expired": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
    "successfully activate vehicle multiple": "{{resourceString}} Fahrzeuge wurden erfolgreich aktiviert.",
    "successfully activate vehicle single": "Fahrzeug erfolgreich aktiviert.",
    "successfully assigned schedules": {
      "multiple": "Fahrpläne erfolgreich zugewiesen.",
      "single": "Zeitplan erfolgreich zugewiesen."
    },
    "successfully deactivate vehicle multiple": "{{resourceString}} Fahrzeuge wurden erfolgreich deaktiviert.",
    "successfully deactivate vehicle single": "Fahrzeug erfolgreich deaktiviert.",
    "successfully deleted": "{{resourceString}} wurde erfolgreich gelöscht.",
    "successfully edited": "{{resourceString}} wurde erfolgreich bearbeitet.",
    "successfully exported": "$t(General##{{tableName}}) wurde erfolgreich exportiert.",
    "successfully imported": "{{resourceString}} wurde erfolgreich importiert.",
    "successfully move vehicles multiple": "{{resourceString}} wurde erfolgreich zu {{companyString}} verschoben.",
    "successfully move vehicles single": "{{resourceString}} wurde erfolgreich zu {{companyString}} verschoben.",
    "successfully remove driver schedules multiple": "Die Zeitpläne von {{resourceString}} Fahrern erfolgreich entfernt.",
    "successfully remove driver schedules single": "Die Zeitpläne für Fahrer {{resourceString}} wurden erfolgreich gelöscht.",
    "successfully remove vehicle schedules multiple": "Die Zeitpläne der Fahrzeuge {{resourceString}} wurde erfolgreich entfernt.",
    "successfully remove vehicle schedules single": "Die Zeitpläne wurden erfolgreich von Fahrzeug {{resourceString}} entfernt.",
    "successfully removed": "{{resourceString}} wurde erfolgreich entfernt.",
    "The company with such name already exists.": "Ein Unternehmen mit diesem Namen existiert bereits.",
    "User is already invited.": "Der Benutzer wurde bereits eingeladen.",
    "User is not invited": "Der Benutzer ist nicht eingeladen.",
    "Vehicle duplication.": "Fahrzeugduplikat.",
    "Vehicle number contains invalid characters.": "Die Fahrzeugnummer enthält ungültige Zeichen.",
    "Vehicle schedule was not found": "Kein Zeitplan für dieses Fahrzeug gefunden.",
    "Vehicle successfully activated": "Fahrzeug erfolgreich aktiviert.",
    "Vehicle with such IMEI already exists.": "Ein Fahrzeug mit dieser IMEI ist bereits vorhanden",
    "Vehicle with such Imei number already exists.": "Die IMEI ist bereits vorhanden.",
    "Vehicle with such number (VRN) already exists.": "Ein Fahrzeug mit diesem VRN existiert bereits",
    "Vehicles schedules were not found": "Keine Zeitpläne für die Fahrzeuge gefunden.",
    "You cannot delete a company you are a member of.": "Das aktuell ausgewählte Unternehmen kann nicht gelöscht werden. Bitte wählen Sie ein anderes Unternehmen aus und wiederholen Sie den Vorgang"
  },
  "Auth": {
    "account verification": {
      "check autheticator": "Überprüfen Sie Ihre Authentifizierungs-App",
      "check email": "Überprüfen Sie Ihre E-Mails",
      "code required": "Bestätigungscode erforderlich.",
      "code sent to email": "Code an Ihre E-Mail gesendet",
      "code valid": "Der Code ist einige Minuten lang gültig.",
      "enter code below": "und geben Sie den Code unten ein, um sich anzumelden."
    },
    "account verification description": "Bestätigungscode erforderlich. Überprüfen Sie Ihre Authentifizierungs-App und geben Sie den Code unten ein, um sich anzumelden.",
    "authenticator": "Authentifizierungs-App",
    "authenticator verification description": "Bestätigungscode erforderlich. Überprüfen Sie Ihre Authentifizierungs-App und geben Sie den Code unten ein, um sich anzumelden.",
    "back to sign in screen": "Zurück zur Anmeldung",
    "check email": "Bitte überprüfen Sie Ihren Posteingang und klicken Sie auf den erhaltenen Link, um Ihr Passwort zurückzusetzen.",
    "community forum": "Community-Forum",
    "contact us": "Kontaktieren Sie uns",
    "create password": "Passwort erstellen",
    "did not receive": "Haben Sie den Link nicht erhalten?",
    "do not have account": "Sie haben noch kein Konto?",
    "email": "E-Mail",
    "enter current password": "Aktuelles Passwort eingeben",
    "enter email": "Bitte geben Sie unten Ihre registrierte E-Mail-Adresse ein, um Anweisungen zum Zurücksetzen Ihres Passworts zu erhalten.",
    "enter here": "Hier eingeben",
    "enter new password": "Neues Passwort eingeben",
    "enter numbers only": "Bitte geben Sie nur Ziffern ein (0–9)",
    "example": "Beispiel:",
    "failed to login": "Die von Ihnen eingegebene E-Mail-Adresse oder das Passwort ist falsch.",
    "forgot password": "Passwort vergessen?",
    "forgot your password": "Passwort vergessen?",
    "go to login": "Zur Anmeldung",
    "google authenticator": "Google Authenticator",
    "hide password": "Passwort ausblenden",
    "invalid email format": "Ungültiges E-Mail-Format",
    "invalid password format": "Ungültiges Passwortformat",
    "Invitation expired": "Der Einladungslink ist abgelaufen oder wurde storniert.",
    "link sent": "Der Link wurde gesendet!",
    "login title": "Anmelden",
    "microsoft authenticator": "Microsoft Authenticator",
    "new password": "Neues Passwort",
    "password": "Passwort",
    "password changed": "Passwort erfolgreich geändert.",
    "privacy policy": "Durch die Nutzung von <1>TachoSync</1> erklären Sie sich mit unserer <3>Datenschutzerklärung einverstanden</3>.",
    "remember password": "Erinnern Sie sich an Ihr Passwort?",
    "repeat new password": "Neues Passwort wiederholen",
    "repeat password": "Passwort wiederholen",
    "required": "Erforderlich",
    "resend": "Erneut senden",
    "reset password": "Passwort zurücksetzen",
    "send reset link": "Link zum Zurücksetzen senden",
    "show password": "Passwort anzeigen",
    "sign in": "Anmelden",
    "sign in to tacho": "Bei Ihrem TachoSync-Konto anmelden",
    "sign out": "Abmelden",
    "sign up": "Registrieren",
    "teltonika telematics": "Teltonika Telematik",
    "terms and conditions": "Ich habe die <1>Nutzungsbedingungen</1> von Teltonika und die <2>Datenverarbeitungsvereinbarung gelesen und </2>akzeptiere sie.",
    "wiki": "Telematik-Wiki-Wissensdatenbank"
  },
  "Button": {
    "accept": "Akzeptieren",
    "accept all": "Alle akzeptieren",
    "accept selected": "Ausgewählte akzeptieren",
    "actions": "Aktionen",
    "activate": "Aktivieren",
    "add": "Hinzufügen",
    "add driver": "Fahrer hinzufügen",
    "add integration": "Integration hinzufügen",
    "add to schedule": "Zum Zeitplan hinzufügen",
    "add vehicle": "Fahrzeug hinzufügen",
    "all drivers": "Alle Fahrer",
    "all vehicles": "Alle Fahrzeuge",
    "apply": "Übernehmen",
    "assign": "Zuweisen",
    "back": "Zurück",
    "back to sign in": "Zurück zur Anmeldung",
    "cancel": "Abbrechen",
    "change": "Ändern",
    "child company": "Tochtergesellschaft",
    "clear": "Zurücksetzen",
    "clear all": "Alle zurücksetzen",
    "close": "Schließen",
    "confirm": "Bestätigen",
    "continue": "Weiter",
    "continue to TachoSync": "Weiter zu TachoSync",
    "copied": "Kopiert",
    "copy to clipboard": "In die Zwischenablage kopieren",
    "create": "Erstellen",
    "create schedule": "Zeitplan erstellen",
    "deactivate": "Deaktivieren",
    "default view": "Standardansicht",
    "delete": "Löschen",
    "deselect all": "Alle abwählen",
    "disable": "Deaktivieren",
    "don't apply": "Nicht übernehmen",
    "download": "Herunterladen",
    "edit": "Bearbeiten",
    "edit driver": "Fahrer bearbeiten",
    "edit integration": "Integration bearbeiten",
    "edit vehicle": "Fahrzeug bearbeiten",
    "enable": "Aktivieren",
    "export": "Export",
    "export drivers": "Fahrer exportieren",
    "export vehicles": "Fahrzeuge exportieren",
    "file settings": "Dateieinstellungen",
    "filtered": "Gefiltert",
    "filters": "Filter",
    "find device": "Gerät suchen",
    "finish": "Fertig",
    "first page": "Startseite",
    "generate": "Erstellen",
    "generate report": "Bericht erstellen",
    "get started": "Los geht's",
    "go back": "Zurück",
    "import": "Import",
    "import drivers": "Fahrer importieren",
    "import vehicles": "Importfahrzeuge",
    "inline actions": {
      "cancel invitation": "Einladung stornieren",
      "download file driver": "Herunterladen",
      "download file vehicle": "Herunterladen",
      "download monitoring": "Download-Überwachung",
      "download status": "Download-Status",
      "edit analysis provider": "Bearbeiten",
      "edit company": "Unternehmen bearbeiten",
      "edit driver": "Fahrer bearbeiten",
      "edit integration": "Integration bearbeiten",
      "edit user": "Benutzer bearbeiten",
      "edit vehicle": "Fahrzeug bearbeiten",
      "resend invitation": "Einladung erneut senden",
      "retry analysis provider": "Erneut versuchen",
      "retry integration": "Erneut versuchen"
    },
    "invite": "Einladen",
    "invite user": "Benutzer einladen",
    "history": "Verlauf",
    "last page": "Letzte Seite",
    "max download files": "Sie können jeweils nur {{maxNumber}} Dateien herunterladen.",
    "more actions": "Weitere Aktionen",
    "more filters": "Weitere Filter",
    "more options": "Weitere Optionen",
    "move": "Verschieben",
    "new client": "Neuer Kunde",
    "next": "Weiter",
    "next month": "Nächsten Monat",
    "next page": "Nächste Seite",
    "only essential": "Nur Erforderliche",
    "open TachoSync": "TachoSync öffnen",
    "pages of": "von {{total}}",
    "pause": "Pause",
    "previous": "Zurück",
    "previous month": "Vormonat",
    "previous page": "Vorherige Seite",
    "quick schedule": "Schnell planen",
    "refresh page": "Seite aktualisieren",
    "reject all": "Alle ablehnen",
    "remove": "Entfernen",
    "remove schedules": "Fahrpläne entfernen",
    "reset": "Zurücksetzen",
    "reset to default": "Standardeinstellung wiederherstellen",
    "resume": "Fortfahren",
    "return home": "Zurück zur Startseite",
    "rows selected": "{{count}} Ausgewählt",
    "save": "Speichern",
    "schedules": "Zeitpläne",
    "select image": "Bild auswählen",
    "select rows": "Zeilen auswählen",
    "selected": "Ausgewählt",
    "send code": "Code senden",
    "settings": "Einstellungen",
    "table view": "Tabellenansicht",
    "testing connection": "Verbindung wird geprüft",
    "verify": "Überprüfen",
    "yes": "Ja"
  },
  "Company cards": {
    "add new": "Neu hinzufügen",
    "badge tooltip": {
      "Disconnected": "Die Verbindung zu TachoSync ist unterbrochen.\nLetzte Verbindung {{connectionDate}}.",
      "Expired": "Die Karte ist aufgrund ihres Ablaufdatums deaktiviert.",
      "Inactive": "Es wurde noch keine erfolgreiche Verbindung zu TachoSync hergestellt.",
      "Online": "Verbindung zu TachoSync erfolgreich hergestellt und aktive Kommunikation gestartet."
    },
    "card expired": "Die Karte ist abgelaufen: {{date}}",
    "card id": "Karten-ID",
    "card number": "Kartennummer",
    "card number tooltip": "Die Kartennummer wird nach der ersten erfolgreichen Autorisierung angezeigt.",
    "cca version": "CCA-Version",
    "company card id": "Firmenkarten-ID",
    "edit card": "Karte bearbeiten",
    "edit company card": "Unternehmensdaten bearbeiten",
    "expiry": "Ablauf",
    "expiry date": "Ablaufdatum: {{date}}",
    "expiry tooltip": "Das Ablaufdatum der Karte wird nach der ersten erfolgreichen Autorisierung angezeigt.",
    "latest version": "Aktuelles",
    "remove card": "Karte entfernen",
    "remove company card": "Firmenkarte entfernen?",
    "remove company card description": "Möchten Sie die Firmenkarte „{{cardName}}“ wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.",
    "status": "Status",
    "update version warning": "Es ist eine neuere Version verfügbar. Installieren Sie diese um die beste Leistung zu erzielen.",
    "valid until": "Gültig bis",
    "version details after connection is established": "Die Versionsdetails werden hier nach der ersten Verbindung über die Firmenkarte angezeigt."
  },
  "Cookies": {
    "accept": "Akzeptieren",
    "always active": "Immer aktiv",
    "analytics cookies": "Analytik-Cookies",
    "analytics cookies description": "Diese Tracker dienen zu Analysezwecken und helfen dabei, Daten zu sammeln, die uns Aufschluss darüber geben, wie Nutzer mit unseren Websites interagieren. Diese Erkenntnisse ermöglichen es uns, sowohl Inhalte zu verbessern als auch bessere Funktionen zu entwickeln, die das Nutzererlebnis optimieren. Diese Kategorie von Cookies kann deaktiviert werden.",
    "cookie banner message": "Wir und ausgewählte Dritte verwenden Cookies oder ähnliche Technologien für technische Zwecke und, mit Ihrer Einwilligung, für andere Zwecke, wie in der <1>Cookie-Richtlinie angegeben</1>.",
    "cookie modal title": "Wir verwenden Cookies",
    "cookie policy": "Cookie-Richtlinie",
    "essential cookies": "Essenzielle Cookies",
    "essential cookies description": "Diese Tracker werden für Aktivitäten verwendet, die für den Betrieb oder die Bereitstellung der von Ihnen angeforderten Dienstleistung unbedingt erforderlich sind. Diese Cookies sammeln keine Informationen über Sie, die für Marketingzwecke verwendet werden könnten, und speichern nicht, welche Seiten Sie im Internet besucht haben. Diese Kategorie von Cookies kann nicht deaktiviert werden.",
    "text": "Diese Website speichert Daten wie Cookies, um die erforderlichen Funktionen der Website, einschließlich Analysen, zu ermöglichen."
  },
  "Dashboard": {
    "added": "Hinzugefügt",
    "Available": "Verfügbar",
    "cards": "Karten",
    "card tooltips": {
      "connectivity": "<strong>Online:</strong>\nDas Gerät hat in den letzten 24 Stunden eine Verbindung hergestellt\n\n<strong>Offline:</strong>\nDas Gerät hat in den letzten 24 Stunden keine Verbindung hergestellt\n\n<strong>Inaktiv:</strong>\nDas Gerät hat noch nie eine erfolgreiche Verbindung mit TachoSync hergestellt",
      "driver downloads": "<strong>Pünktlich:</strong>\n0–14 Tage seit dem letzten Download\n\n<strong>In Kürze verfügbar:</strong>\n15–28 Tage seit dem letzten Download\n\n<strong>Überfällig:</strong>\n29+ Tage seit dem letzten Download\n\n<strong>Keine Downloads:</strong>\nEs wurden noch keine Downloads durchgeführt",
      "vehicle downloads": "<strong>Pünktlich:</strong>\n0–60 Tage seit dem letzten Download\n\n<strong>In Kürze verfügbar:</strong>\n61–90 Tage seit dem letzten Download\n\n<strong>Überfällig:</strong>\n91+ Tage seit dem letzten Download\n\n<strong>Keine Downloads:</strong>\nEs wurden noch keine Downloads durchgeführt"
    },
    "cc expiry": {
      "expired": "Abgelaufen",
      "near expiry": "Ablauf steht kurz bevor",
      "near expiry tooltip": "Läuft in 3 Monaten ab",
      "upcoming expiry": "Bevorstehendes Ablaufdatum",
      "upcoming expiry tooltip": "Läuft in 3–6 Monaten ab"
    },
    "company cards": "Firmenkarten",
    "company cards expiration": "Ablauf von Firmenkarten",
    "connectivity": "Konnektivität",
    "connectivity tabs": {
      "company cards": "Firmenkarten",
      "devices": "Geräte"
    },
    "credit overdraft activated": "Mit dem Überziehungskredit können Sie bis zu {{overDraftAmount}} Credits über Ihr Guthaben hinaus nutzen.",
    "credits": "Guthaben",
    "credits health": {
      "Healthy": "Einwandfrei",
      "InOverdraft": "Überziehung",
      "LimitReached": "Limit erreicht",
      "LowCredits": "Guthaben knapp",
      "OverdraftLimitReached": "Limit erreicht"
    },
    "credits history": "Guthabenverlauf",
    "credits history actions": {
      "BonusCredits": "Bonuspunkte",
      "CreditsExpiration": "Ablauf der Gültigkeit von Guthaben",
      "Deduction": "Monatlicher Abzug",
      "FreeTrial": "Demo-Guthaben hinzugefügt",
      "MonthlyDeduction": "Monatlicher Abzug",
      "Purchase": "Guthaben hinzugefügt",
      "WebTachoLicenseConversion": "Migration"
    },
    "credits statuses": {
      "available": "Verfügbar",
      "balance": "Saldo",
      "overdraft": "Überziehungskredit",
      "remaining overdraft": "Verbleibender Überziehungskredit",
      "reserved": "Reserviert"
    },
    "Deactivated": "Deaktiviert",
    "deducted": "Abgezogen",
    "demo credits": {
      "demo": "Demo",
      "demo credits expired tooltip": "Die Demo-Guthaben sind abgelaufen. Bitte kaufen Sie Guthaben, um TachoSync weiterhin nutzen zu können.",
      "demo credits used up tooltip": "Alle Demo-Guthaben sind aufgebraucht. Bitte kaufen Sie Guthaben, um TachoSync weiterhin nutzen zu können.",
      "demo info tooltip": "Die Demo-Guthaben werden bei der ersten IMEI-Verbindung aktiviert und bleiben 90 Tage lang aktiv."
    },
    "device status": "Gerätestatus",
    "devices": "Geräte",
    "driver data": "Fahrerdaten",
    "driver downloads": "Fahrer-Downloads",
    "DueSoon": "In Kürze verfügbar",
    "estimated": "Geschätzt",
    "expires": "Läuft ab",
    "how credits work": {
      "bottom content": {
        "header": "Wann wird ein Guthaben reserviert?",
        "table": {
          "body": {
            "any": "Beliebig",
            "any behaviour": "Keine neue Gutschrift. Bestehende Reservierung bleibt bis zum Monatsende bestehen.",
            "newly assigned": "Neu zugewiesen",
            "newly assigned behaviour": "Bei Verbindung reserviert. Nach dem ersten Download auf VIN migriert.",
            "replaced vin known": "Ersetzt (Fahrgestellnummer bekannt)",
            "replaced vin known behaviour": "Keine neue Gutschrift. Die bestehende Reservierung bleibt weiterhin gültig.",
            "none": "Keine",
            "none behaviour": "Es wurde kein Guthaben reserviert. Der Download beginnt erst, wenn ein Gerät zugewiesen wurde."
          },
          "head": {
            "credit behaviour": "Kreditverhalten",
            "device": "Gerät",
            "vehicle status": "Fahrzeugstatus"
          }
        }
      },
      "button tooltip": "So funktionieren Credits",
      "main description": "TachoSync-Guthaben sind 12 Monate lang gültig. Mit jedem Neukauf verlängert sich die Gültigkeitsdauer um weitere 12 Monate, sodass Ihr Guthaben so lange verfügbar bleibt, wie Sie aktiv sind.",
      "main title": "So funktionieren Credits",
      "middle content": {
        "description": "Die Kreditnutzung Ihrer Flotte spiegelt anhand der eindeutigen Fahrgestellnummer (VIN) genau wider, wie viele Fahrzeuge aktiv sind. Geräte können ausgetauscht, zwischen Fahrzeugen versetzt oder innerhalb von Tochterunternehmen neu zugewiesen werden, ohne dass ein zusätzlicher Kredit verbraucht wird, sofern die Identität des Fahrzeugs bereits feststeht.",
        "header": "Die Guthaben werden pro aktivem Fahrzeug und nicht pro Gerät reserviert.",
        "read more on wiki": "Mehr dazu im Wiki"
      },
      "top content": {
        "active vehicle": "Aktives Fahrzeug",
        "device can change freely": "Das Gerät kann beliebig gewechselt werden",
        "equals one credit": "= 1 Kreditpunkt",
        "identified by IMEI": "Identifiziert anhand der IMEI",
        "identified by VIN": "Identifiziert anhand der Fahrgestellnummer (VIN)",
        "tracking device": "Ortungsgerät"
      }
    },
    "Inactive": "Inaktiv",
    "last 12 months": "Letzte 12 Monate",
    "news": "Nachrichten",
    "no history to show": "Es sind keine Einträge vorhanden",
    "no news": "Keine Nachrichten vorhanden",
    "no results": "Keine Ergebnisse",
    "NoDownloads": "Keine Downloads",
    "Offline": "Offline",
    "Online": "Online",
    "OnTime": "Pünktlich",
    "Overdue": "Überfällig",
    "Remaining": "Verbleibend",
    "Reserved": "Reserviert",
    "response error": "Es ist ein Fehler aufgetreten. Bitte aktualisieren Sie die Seite.",
    "timeline": "Zeitleiste",
    "tooltip": {
      "click to expand": "Zum Erweitern hier klicken",
      "connected card expire soon": "Die Karte läuft bald ab: {{expirationDate}}",
      "disconnected card": "Die Firmenkarte ist getrennt.\nZuletzt gesehen: {{lastSeen}}.",
      "disconnected card expire soon": "Die Firmenkarte ist getrennt.\nZuletzt gesehen: {{lastSeen}}. \n \n Die Karte läuft bald ab: {{expirationDate}}.",
      "expired card": "Die Karte ist am {{expirationDate}} abgelaufen.\nErsetzen Sie die Firmenkarte durch eine gültige.",
      "offline card": "Die Firmenkarte ist offline.\nZuletzt gesehen: {{lastSeen}}.",
      "take me there": "Dorthin"
    },
    "Upcoming charge": "Anstehende Gebühr",
    "vehicle data": "Fahrzeugdaten",
    "vehicle downloads": "Fahrzeug-Downloads",
    "view history": "Verlauf anzeigen"
  },
  "Date picker": {
    "disableFuture": "Datum deaktiviert",
    "disablePast": "Datum deaktiviert",
    "invalid date format": "Ungültiges Datumsformat",
    "invalidDate": "Ungültiges Datum",
    "maxDate": "Falsches Datum",
    "minDate": "Falsches Datum",
    "shouldDisableDate": "Datum deaktiviert"
  },
  "Details": {
    "activities": "Aktivitäten",
    "add new email recipient": {
      "choose a file format": "Wählen Sie ein Dateiformat",
      "enter email": "E-Mail-Adresse eingeben",
      "title": "Neuen Empfänger hinzufügen"
    },
    "api company id": "API-Unternehmens-ID",
    "autoAssignGlobalScheduleToDriver": "Neuen Fahrern globalen Zeitplan zuweisen",
    "autoAssignGlobalScheduleToVehicle": "Neuen Fahrzeugen globalen Zeitplan zuweisen",
    "automaticDriverRegistrationEnabled": "Neue Fahrer automatisch registrieren",
    "card holder": "Name des Karteninhabers",
    "client code": "Kundenkennung",
    "close details": "Details schließen",
    "company": "Unternehmen",
    "company cards": "Firmenkarten",
    "company cards limit reached": "Sie haben die maximale Anzahl an Firmenkarten für dieses Unternehmen erreicht: {{currCount}}/{{maxCount}}.",
    "company settings": "Unternehmenseinstellungen",
    "Completed": "Abgeschlossen",
    "connection settings": "Verbindungseinstellungen",
    "creator": "Ersteller",
    "credits": "Guthaben",
    "credits overdraft tooltip": "Die Logik für die monatliche Guthabenreservierung wurde angepasst, sodass ein negativer Kontostand möglich ist. Das ermöglicht einen reibungsloseren Umstieg von Web Tacho, ohne dass Nutzer sofort Guthaben kaufen müssen.",
    "current status": "Aktueller Status",
    "Daily": "Täglich",
    "data types": "Datentypen",
    "deactivated": "Deaktiviert",
    "deactivated vehicle banner": {
      "description": "Dieses Fahrzeug reserviert keine neuen Guthaben, und die Fahrzeugdateien können erst nach der Aktivierung heruntergeladen werden.",
      "link": "Fahrzeug aktivieren",
      "title": "Fahrzeug ist deaktiviert"
    },
    "detailed speed": "Detaillierte Geschwindigkeit",
    "details": "Details",
    "device imei": "IMEI",
    "device status": "Gerätestatus",
    "download status": "Download-Status",
    "download time": "Download-Zeit",
    "DownloadPending": "Download steht noch aus",
    "driver": "Fahrer",
    "driver id": "Fahrer-ID",
    "driver status": "Fahrerstatus",
    "drivers": "Fahrer",
    "edit": "Bearbeiten",
    "edit user": "Bearbeiten {{userEmail}}",
    "email limit reached": "Sie haben die maximale Anzahl an E-Mails für dieses Unternehmen erreicht.",
    "email transfer": "E-Mail-Tranfer",
    "email transfer info tooltip": "Die E-Mail-Übertragungsfunktion sendet heruntergeladene Tachographendaten automatisch an konfigurierte Empfänger, sobald ein Zeitplan abgeschlossen ist. Pro Unternehmen können bis zu {{maxCount}} E-Mail-Empfänger hinterlegt werden.",
    "endpointUrl": "Endpunkt-URL",
    "events and faults": "Ereignisse und Fehler",
    "Every  days": "Alle {{count}} Tage",
    "Every month": "Jeden Monat",
    "EveryDays": "Alle {{count}} Tage",
    "Feature not available in BETA version": "Funktion in der BETA-Version nicht verfügbar",
    "file format": "Dateiformat",
    "file sync": "Dateisynchronisierung",
    "general": "Allgemeines",
    "host": "Host",
    "imei": "IMEI",
    "included": "Enthalten",
    "integration method": {
      "Ftps": "FTPS",
      "Sftp": "SFTP",
      "Webhook": "Webhook"
    },
    "last activity": "Letzte Aktivität",
    "last download attempt": "Letzter Download-Versuch",
    "last successful download": "Letzter erfolgreicher Download",
    "Never": "Nie",
    "next download": "Nächster Download",
    "next download attempt": "Nächster Download-Versuch",
    "Next download attempt in  day": "Nächster Download-Versuch in {{count}} Tagen",
    "Next download attempt in  days": "Nächster Download-Versuch in {{count}} Tagen",
    "no company cards": "Es wurden keine Firmenkarten hinzugefügt.",
    "no driver schedule": "Für den Fahrer sind keine Zeitpläne hinterlegt.",
    "no recipients added": "Es wurden keine Empfänger hinzugefügt",
    "no vehicle schedule": "Für das Fahrzeug sind keine Zeitpläne hinterlegt.",
    "not included": "Nicht enthalten",
    "on next connection": "Bei der nächsten Verbindung",
    "open files": "Dateien öffnen",
    "open files disabled tooltip": "Für dieses Objekt sind keine Dateien verfügbar.",
    "other": "Sonstiges",
    "overview": "Übersicht",
    "parent company": "Muttergesellschaft",
    "password": "Passwort",
    "port": "Port",
    "Quick schedule was completed": "Der Schnellplan wurde fertiggestellt",
    "remotePath": "Pfad zum Remote-Verzeichnis",
    "remove": "Entfernen",
    "remove email recipient": {
      "description": "Möchten Sie diesen E-Mail-Empfänger wirklich entfernen? Dieser Vorgang kann nicht rückgängig gemacht werden.",
      "title": "{{userEmail}} entfernen?"
    },
    "remove schedule": "Zeitplan entfernen",
    "reserved": "Reserviert",
    "schedule details": "Details zum Zeitplan",
    "schedule history": "Zeitplanverlauf",
    "schedule start time": "Startzeit des Zeitplans",
    "schedules": "Zeitpläne",
    "show less": "Weniger anzeigen",
    "show more": "Mehr anzeigen",
    "show older": "Ältere anzeigen",
    "status": "Status",
    "sub companies": "Tochtergesellschaften",
    "technical data": "Technische Daten",
    "Upon device connection": "Verbindung zum Gerät",
    "username": "Benutzername",
    "users": "Benutzer",
    "vehicles": "Fahrzeuge",
    "vrn": "Kennzeichen",
    "WaitingForDeviceConnection": "Warten auf Geräteverbindung",
    "WaitingForScheduleStartTime": "Warte auf den Start des Zeitplans"
  },
  "Dialog": {
    "account id": "Konto-ID",
    "account id cannot contain more than": "Die Konto-ID darf nicht mehr als {{maxNumber}} Zeichen enthalten",
    "activate vehicles": {
      "description": "Nach der Aktivierung können Fahrzeuge Guthaben auf Basis einer einmaligen monatlichen Verbindung reservieren. Möchten Sie die folgende Anzahl an Fahrzeugen wirklich aktivieren?",
      "title": "Fahrzeuge aktivieren?"
    },
    "add": "Hinzufügen",
    "add company card": "Neue Firmenkarte hinzufügen",
    "add driver": "Fahrer hinzufügen",
    "add integration": "Integration hinzufügen",
    "add new integration": {
      "description": "Wählen Sie die Art der Integration aus, die Sie hinzufügen möchten, und konfigurieren Sie diese im nächsten Schritt.",
      "title": "Neue Integration hinzufügen"
    },
    "add vehicle": "Fahrzeug hinzufügen",
    "add vehicle description": "Fahrzeug manuell anhand der Zulassungsdaten hinzufügen.",
    "add vehicle imei in use accessible": {
      "description": "Diese IMEI ist bereits mit einem anderen Fahrzeug verknüpft. Durch die Neuzuweisung wird dieses Fahrzeug von den Dateidownloads getrennt. Möchten Sie wirklich fortfahren?",
      "title": "IMEI bereits in Gebrauch",
      "vehicle imei": "Fahrzeug mit der IMEI „{{imeiValue}}“:"
    },
    "all resource": "Alle {{resource}}",
    "api key": "API-Schlüssel",
    "api key placeholder": "API-Schlüssel eingeben",
    "api key cannot contain more than": "Der API-Schlüssel darf nicht mehr als {{maxNumber}} Zeichen enthalten",
    "api key edit": {
      "dialog title": "API-Schlüssel „{{keyName}}“ bearbeiten",
      "success banner": "API-Schlüssel erfolgreich bearbeitet."
    },
    "api key name": "Schlüsselname",
    "api key name required": "Der Schlüsselname darf nicht leer sein",
    "api key name too long": "Der Schlüsselname darf nicht mehr als {{maxNumber}} Zeichen enthalten",
    "api management": {
      "description": "Mit Ihrem API-Schlüssel verbinden Sie TachoSync sicher mit Ihrer eigenen Software und Ihren Arbeitsabläufen. Die API-Dokumentation finden Sie",
      "generated api key": "Generierter API-Schlüssel",
      "success banner": "Ihr API-Schlüssel wurde erfolgreich erstellt. Speichern Sie die folgenden Informationen jetzt, da sie nach dem Schließen dieses Fensters nicht mehr einsehbar sind."
    },
    "cancel invitation": "Einladung stornieren",
    "cancel invitation description": "Möchten Sie die Einladung für {{userEmail}} wirklich widerrufen?",
    "card holder name": "Name des Karteninhabers",
    "card holder name not valid": "Der Name des Karteninhabers darf nicht mehr als {{maxNumber}} Zeichen enthalten",
    "card holder name should not be empty": "Der Name des Karteninhabers darf nicht leer sein",
    "card holder name too short": "Der Name des Karteninhabers muss mindestens {{minNumber}} Zeichen enthalten",
    "card id not valid": "Die Karten-ID darf nicht mehr als {{maxNumber}} Zeichen enthalten",
    "card id should contain only digits, letters and hyphens": "Die Karten-ID darf nur Ziffern (0–9), Buchstaben A–F und Bindestriche (-) enthalten.",
    "card id should contain only numbers": "Die Karten-ID darf nur Zahlen enthalten",
    "card id should not be empty": "Die Karten-ID darf nicht leer sein",
    "card id too short": "Die Karten-ID muss mindestens {{minNumber}} Zeichen enthalten",
    "card name": "Kartenname",
    "card name not valid": "Der Name der Karte darf nicht mehr als {{maxNumber}} Zeichen enthalten",
    "card name should not be empty": "Der Name der Karte darf nicht leer sein",
    "card name too short": "Der Name der Karte muss mindestens {{minNumber}} Zeichen enthalten",
    "choose period": "Zeitraum auswählen",
    "client company": "Kundenunternehmen",
    "company": "Unternehmen",
    "company card id": "Firmenkarten-ID",
    "company name": "Firmenname",
    "company name in tachoSync": "Firmenname in TachoSync",
    "company name placeholder": "Beispiel: Teltonika Telematics",
    "company settings": {
      "allow credits overdraft": "Kreditüberziehung zulassen",
      "auto add new drivers": "Neue Fahrer automatisch registrieren",
      "auto add new drivers tooltip": "Sobald eine neue Fahrer-ID erkannt wird, fügt TachoSync diese automatisch zur Fahrertabelle hinzu.",
      "auto assign global schedule to drivers": "Globalen Zeitplan neuen Fahrern automatisch zuweisen",
      "auto assign global schedule to drivers tooltip": "Wendet automatisch einen globalen Download-Zeitplan auf neu registrierte Fahrer an und gewährleistet so den Daten-Download ohne manuellen Eingriff.",
      "auto assign global schedule to vehicles": "Globalen Zeitplan automatisch neuen Fahrzeugen zuweisen",
      "auto assign global schedule to vehicles tooltip": "Wendet automatisch einen globalen Download-Zeitplan auf neu registrierte Fahrzeuge an und gewährleistet so den Daten-Download ohne manuellen Eingriff.",
      "auto download driver data": "Automatischer Download der Fahrerdaten bei der ersten Verbindung",
      "auto download driver data tooltip": "Lädt die Daten der Fahrerkarte automatisch herunter, sobald sich ein Fahrer zum ersten Mal anmeldet. Dadurch wird sichergestellt, dass für neue Fahrer die gesamte Historie erfasst wird, bevor Zeitpläne erstellt werden.",
      "auto update vehicle registration number": "Automatische Aktualisierung des Fahrzeugkennzeichens (VRN)",
      "auto update vehicle registration number tooltip": "Wenn diese Option aktiviert ist, wird das bei der Fahrzeuganlage eingegebene VRN nach dem ersten erfolgreichen Download durch den aus den Tachographendaten ausgelesenen Wert überschrieben.",
      "automatic initial vehicle download": "Automatischer Download der Fahrzeugdaten bei der ersten Verbindung",
      "automatic initial vehicle download tooltip": "Lädt Fahrzeugdaten automatisch herunter, sobald ein Fahrzeug zum ersten Mal verbunden wird. Dadurch wird sichergestellt, dass für Neufahrzeuge die gesamte Historie erfasst wird, bevor Zeitpläne eingerichtet werden.",
      "title": "Unternehmenseinstellungen"
    },
    "confirm add schedule": "Zeitplan hinzufügen?",
    "confirm deactivate api key": {
      "description": "Möchten Sie den API-Schlüssel „{{apiKeyName}}“ wirklich deaktivieren?",
      "title": "API-Schlüssel deaktivieren?"
    },
    "confirm deactivate integration": {
      "description": "Möchten Sie die Integration „{{integrationName}}“ wirklich deaktivieren?",
      "title": "Integration deaktivieren?"
    },
    "confirm delete analysis providers": "Möchten Sie die folgende Anzahl von Analyseanbietern wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.",
    "confirm delete api credentials": "Möchten Sie die ausgewählten API-Anmeldedaten wirklich löschen? Nach dem Löschen werden alle zugehörigen API-Aufrufe sofort abgelehnt. Dieser Vorgang kann nicht rückgängig gemacht werden.",
    "confirm delete companies": "Möchten Sie das ausgewählte Unternehmen wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.",
    "confirm delete drivers": "Möchten Sie die folgende Anzahl von Fahrern wirklich löschen?",
    "confirm delete integrations": "Möchten Sie die folgende Anzahl an Integrationen wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.",
    "confirm delete users": "Möchten Sie die folgende Anzahl von Benutzern wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.",
    "confirm delete vehicles": "Möchten Sie die folgende Anzahl an Fahrzeugen wirklich löschen?",
    "confirm empty imei": {
      "description": "Sie haben das IMEI-Feld nicht ausgefüllt. Fahrzeuge ohne IMEI können keine Verbindung zu TachoSync herstellen und keine Dateien herunterladen.\nMöchten Sie wirklich fortfahren?",
      "title": "Keine IMEI hinzugefügt"
    },
    "convey integration": {
      "add": {
        "description": "Konfigurieren Sie Ihre Convey-Verbindung",
        "title": "Convey-Integration hinzufügen"
      },
      "edit": {
        "description": "Konfigurieren Sie Ihre Convey-Verbindung",
        "title": "Convey-Integration bearbeiten"
      },
      "provider settings description": "Verwenden Sie unbedingt die von Convey bereitgestellten Zugangsdaten.",
      "provider settings title": "Anbietereinstellungen"
    },
    "create": "Erstellen",
    "create company": "Unternehmen anlegen",
    "create company main description": "Wählen Sie, ob Sie ein neues Tochterunternehmen innerhalb dieser Hierarchie anlegen oder einen neuen Kunden unter Verwendung eines Kunden-LZ-Codes anlegen möchten.",
    "create new hierarchy": "Neue Hierarchie erstellen",
    "create news": "Nachricht erstellen",
    "create news description": "Beschreiben Sie kurz den Inhalt dieser Meldung.",
    "create quick schedule": "Schnellen Zeitplan erstellen",
    "create schedule": "Zeitplan erstellen",
    "create schedule description": "Automatisieren Sie Dateidownloads durch Festlegen von Datum, Uhrzeit und Intervall. Das System übernimmt die Ausführung und sorgt für Vorschriftskonformität und Datengenauigkeit. Der Startzeitpunkt muss in der Zukunft liegen.",
    "credits history": {
      "description": "Guthabenstand und Verlauf im Überblick.",
      "description generate report": "Guthabenstand einsehen, Verlauf abrufen und Verbrauch der letzten 12 Monate als CSV exportieren.",
      "generate report description": "Wählen Sie einen Zeitraum innerhalb der letzten 12 Monate aus und exportieren Sie einen Bericht über den Guthabenverbrauch.",
      "generate report title": "Bericht erstellen",
      "title": "Kreditverlauf"
    },
    "custom period": "Benutzerdefinierter Zeitraum",
    "date display format": "Datumsanzeigeformat",
    "date range": "Datumsbereich",
    "deactivate vehicle": "Dieses Fahrzeug deaktivieren",
    "deactivate vehicle description": "Deaktivierte Fahrzeuge erhalten keine neuen Guthaben und können keine Daten herunterladen",
    "deactivate vehicles": {
      "description": "Bei deaktivierten Fahrzeugen werden keine neuen Guthaben reserviert, und der Herunterladen von Daten wird gesperrt.",
      "title": "Fahrzeuge deaktivieren?"
    },
    "delete": "Löschen",
    "delete analysis providers": "Analyseanbieter löschen?",
    "delete api credentials": "API-Anmeldedaten löschen?",
    "delete companies": "Unternehmen löschen?",
    "delete companies warning": "Durch das Löschen von Unternehmen werden alle Ressourcen gelöscht, die zu diesen Unternehmen gehören.",
    "delete drivers": "Fahrer löschen?",
    "delete integrations": "Integrationen löschen?",
    "delete news": "Beitrag löschen",
    "delete news description": "Ausgewählte Beiträge wirklich löschen?",
    "delete unpublished release notes": "Unveröffentlichte Versionshinweise löschen?",
    "delete unpublished release notes description": "Möchten Sie die unveröffentlichten Versionshinweise wirklich löschen?",
    "delete users": "Benutzer löschen?",
    "delete vehicles": "Fahrzeuge löschen?",
    "description": "Beschreibung (optional)",
    "description not valid": "Die Beschreibung darf nicht mehr als {{maxNumber}} Zeichen enthalten",
    "description required": "Beschreibung",
    "description should not be empty": "Die Beschreibung darf nicht leer sein",
    "device imei": "Geräte-IMEI",
    "dialog description": {
      "create company description": "Die maximal zulässige Anzahl von Unternehmensebenen in einer Unternehmensstruktur beträgt {{maxNumber}}.",
      "create new hierarchy description": "Die maximal zulässige Anzahl von Unternehmensebenen in einer Unternehmensstruktur beträgt {{maxNumber}}. Wählen Sie aus, ob Sie ein neues untergeordnetes Unternehmen innerhalb dieser Hierarchie erstellen oder einen neuen Kunden mit einem Client-LZ-Code anlegen möchten."
    },
    "download activities": "Download-Aktivitäten",
    "download blocked message": "Download gesperrt - wenden Sie sich zur Behebung des Problems an Ihren Anbieter.",
    "download data types": "Arten von herunterladbaren Daten",
    "download drivers files": "Fahrerdaten herunterladen",
    "download history dialog title": "Verlauf von {{vehicleNumber}}",
    "download monitoring dialog tooltip": "Alle Daten in dieser Ansicht werden alle <strong>10 Sekunden</strong> automatisch aktualisiert.\nDer Gerätestatus gibt die letzte Verbindung wieder - nicht den aktuellen Zustand des Fahrzeugs.",
    "download only selection": "Es werden nur die ausgewählten Dateien heruntergeladen.",
    "download sample file message": "Laden Sie eine <1>CSV-Vorlage</1> herunter, um das erforderliche Format einzusehen.",
    "download status banners": {
      "CompanyCardExpired": "Die Firmenkarte ist abgelaufen. Bitte fügen Sie eine gültige Firmenkarte hinzu.",
      "InsufficientCredits": "Nicht genügend Guthaben. Bitte laden Sie Guthaben auf, um Dateien herunterzuladen.",
      "NoCompanyCards": "Eine Firmenkarte muss online sein, um den Download zu starten. Derzeit sind keine verfügbar.",
      "NoSchedulesApplied": "Für dieses Fahrzeug sind keine Zeitpläne hinterlegt.",
      "VehicleDeactivated": "Dieses Fahrzeug ist deaktiviert und kann den Download-Vorgang nicht starten."
    },
    "download status dialog title": "Überwachung der Downloads von {{vehicleNumber}}",
    "download vehicles files": "Fahrzeugdateien herunterladen",
    "driver file destination": "Speicherort der Fahrerdateien",
    "driver file destination tooltip": "Wählen Sie aus, ob Fahrerdateien im Ordner des Fahrzeugs gespeichert werden sollen, von dem sie heruntergeladen wurden, oder in speziellen Fahrerordnern nach Fahrer-ID.",
    "driver folder": "Fahrerordner",
    "driver id": "Fahrer-ID",
    "driver id not valid": "Die Fahrer-ID sollte {{maxNumber}} alphanumerische Zeichen enthalten",
    "driver id placeholder": "Beispiel: 360896050032309",
    "driver id should not be empty": "Die Fahrer-ID darf nicht leer sein",
    "driver name": "Name des Fahrers",
    "drivers folder naming": "Benennung von Fahrern-Ordnern",
    "edit company": "Unternehmen „{{name}}“ bearbeiten",
    "edit driver": "Fahrer „{{name}}“ bearbeiten",
    "edit news": "Nachricht bearbeiten",
    "edit release notes tooltip": "Diese Nachrichten werden als Versionshinweise erstellt und können nicht geändert werden.",
    "edit user": "Benutzer bearbeiten",
    "edit vehicle": "Fahrzeug „{{name}}“ bearbeiten",
    "edit vehicle imei in use accessible": {
      "description": "Diese IMEI ist bereits einem anderen Fahrzeug zugewiesen. Sie können die IMEI zwischen den beiden Fahrzeugen austauschen oder die IMEI überschreiben.",
      "title": "IMEI bereits in Gebrauch"
    },
    "email": "E-Mail",
    "endpointUrl": "Endpunkt-URL",
    "endpoint url": "Endpunkt-URL",
    "endpoint url not valid": "Die Endpunkt-URL ist ungültig",
    "endpoint url placeholder": "URL eingeben",
    "enter": "Eingeben",
    "enter company card id": "Bitte geben Sie die Firmenkarten-ID ein, die Sie in der Anwendung „Company Card Authenticator“ finden.",
    "enter here": "Hier eingeben",
    "enter name": "Name eingeben",
    "enter password": "Passwort eingeben",
    "enter username": "Benutzername eingeben",
    "expiration date optional": "Ablaufdatum (optional)",
    "export drivers": {
      "description": "Exportieren Sie alle Fahrer des ausgewählten Unternehmens in die gewünschten CSV-Dateien.",
      "include drivers from all companies": "Fahrer aller Unternehmen einbeziehen",
      "title": "Fahrer exportieren"
    },
    "export vehicles": {
      "description": "Exportieren Sie alle Fahrzeuge des ausgewählten Unternehmens in die gewünschten CSV-Dateien.",
      "include vehicles from all companies": "Fahrzeuge aller Unternehmen einbeziehen",
      "selected vehicles": "Ausgewählte Fahrzeuge des Unternehmens",
      "title": "Fahrzeuge exportieren"
    },
    "feature switches": {
      "feature switches": "Funktionsschalter",
      "toggle integrations page": "Seite „Integrationen aktivieren“"
    },
    "field cannot be changed": "Dieses Feld kann nicht geändert werden",
    "field cannot be empty": "{{fieldName}} darf nicht leer sein",
    "field length not valid": "Dieses Feld darf nicht mehr als {{maxNumber}} Zeichen enthalten",
    "file format": "Dateiformat",
    "filtered resource": "Gefiltert {{resource}}",
    "filtered drivers": "Gefilterte Fahrer",
    "filtered vehicles": "Gefilterte Fahrzeuge",
    "from": "Von",
    "future dates": {
      "1 day": "in 1 Tag",
      "1 minute": "in 1 Minute",
      "1 month": "in 1 Monat",
      "1 week": "in 1 Woche",
      "1 year": "in 1 Jahr",
      "hours and minutes": "in {{hourCount}} Std. {{minutesCount}} Min.",
      "less than a minute": "in <1 Minute",
      "multiple days": "in {{daysCount}} Tagen",
      "multiple minutes": "in {{minutesCount}} Minuten",
      "multiple months": "in {{monthsCount}} Monaten",
      "multiple weeks": "in {{weeksCount}} Wochen",
      "multiple years": "in {{yearsCount}} Jahren"
    },
    "generate api key": {
      "title": "API-Schlüssel generieren"
    },
    "host": "Host",
    "host cannot contain more than": "Der Host darf nicht mehr als {{maxNumber}} Zeichen enthalten",
    "imei": "IMEI",
    "imei not valid": "Die IMEI sollte {{maxNumber}} Ziffern enthalten",
    "imei placeholder": "Beispiel: 360896050032309",
    "imei should not be empty": "IMEI darf nicht leer sein",
    "import drivers": "Fahrer importieren",
    "import drivers description": "Fügen Sie Fahrer zu Ihrer Liste hinzu, indem Sie sie aus einer Datei importieren.",
    "import vehicles": "Importfahrzeuge",
    "import vehicles description": "Fügen Sie Fahrzeuge zu Ihrer Liste hinzu, indem Sie sie aus einer Datei importieren.",
    "integration name": "Name der Integration",
    "integration type": "Art der Integration",
    "integrations": {
      "deactivate integration": {
        "title": "Diese Integration deaktivieren",
        "tooltip": "Deaktivieren Sie die Integration vorübergehend. Sie können sie wieder aktivieren, indem Sie diese Option deaktivieren."
      },
      "deactivate api key": "API-Schlüssel deaktivieren",
      "deactivate sftp": "SFTP deaktivieren",
      "deactivate integration tooltip": "Deaktivieren Sie die Integration vorübergehend. Sie können sie wieder aktivieren, indem Sie diese Option deaktivieren.",
      "disable integration": {
        "description": "Möchten Sie die Integration „{{integrationName}}“ wirklich deaktivieren?",
        "title": "Integration deaktivieren?"
      },
      "driver files info banner": "Bitte beachten Sie: Fahrerdateien, die vor dem {{formattedDate}} heruntergeladen wurden, werden automatisch in den Ordner des zuletzt vom Fahrer gefahrenen Fahrzeugs verschoben.",
      "errors": {
        "AuthenticationFailed": {
          "description": "Bitte stellen Sie sicher, dass Ihr Benutzername und Ihr Passwort korrekt eingegeben wurden.\nDie Integration wird mit dem Status „Fehlgeschlagen“ gespeichert, bis die korrekten Anmeldedaten eingegeben wurden.",
          "title": "Falsche Anmeldedaten."
        },
        "FolderCreationFailed": {
          "description": "TachoSync ist mit dem Server verbunden, verfügt jedoch nicht über die Berechtigung, Ordner zu erstellen oder Dateien in den Zielpfad hochzuladen.\nDie Integration wird mit dem Status „Fehlgeschlagen“ gespeichert, bis das Problem behoben ist und Sie die Verbindung erneut herstellen.",
          "title": "Schreibzugriff fehlt."
        },
        "HostUnreachable": {
          "description": "Bitte stellen Sie sicher, dass die Serveradresse und der Port korrekt sind und der Server online ist.\nDie Integration wird mit dem Status „Fehlgeschlagen“ gespeichert, bis das Problem behoben ist und Sie die Verbindung erneut herstellen.",
          "title": "Host nicht erreichbar."
        },
        "PathNotFound": {
          "description": "Das angegebene Verzeichnis konnte auf dem Server nicht gefunden werden. Bitte stellen Sie sicher, dass der Pfad korrekt ist.\nDie Integration wird mit dem Status „Fehlgeschlagen“ gespeichert, bis ein korrekter Pfad angegeben wird.",
          "title": "Pfad nicht gefunden."
        },
        "PermissionDenied": {
          "description": "Bitte stellen Sie sicher, dass TachoSync über die erforderlichen Berechtigungen für den Zugriff auf diesen Pfad verfügt.\nDie Integration wird mit dem Status „Fehlgeschlagen“ gespeichert, bis die Berechtigungen aktualisiert wurden und Sie die Verbindung erneut herstellen.",
          "title": "Zugriff auf den Pfad verweigert."
        },
        "Unknown": {
          "description": "Die Verbindung zum SFTP-Server ist fehlgeschlagen. Bitte prüfen Sie Ihre Serverdaten und Einstellungen. Die Integration bleibt als 'Fehlgeschlagen' markiert, bis das Problem behoben ist",
          "title": "Es ist ein unerwarteter Fehler aufgetreten."
        }
      },
      "include files from all sub companies": "Dateien aller Tochterunternehmen einbeziehen",
      "include files tooltip": "Bei Auswahl dieser Integration werden auch Dateien aller Tochterunternehmen Ihres Kontos abgerufen.",
      "include historical files": "Historische Dateien einbeziehen",
      "include historical files tooltip": "Bei Auswahl dieser Option werden auch Dateien abgerufen, die vor Einrichtung dieser Integration heruntergeladen wurden.",
      "select driver files destination": "Zielort für Fahrerdateien auswählen"
    },
    "introduce name": "Name eingeben",
    "invite user": "Benutzer einladen",
    "invite user description": "Sobald die Einladung versendet wurde, erhält der Nutzer eine \nE-Mail mit einem Link zur Kontoerstellung. Der Link ist 7 Tage lang gültig.",
    "invite user sent": "Benutzereinladung erfolgreich gesendet.",
    "loading": "Wird geladen...",
    "make release notes": "Release-Hinweise erstellen",
    "make release notes info": "Wenn dieses Feld ausgewählt ist, wird die Nachricht in den Versionshinweisen veröffentlicht und der Titel in „Versionshinweise“ geändert.",
    "max download files": "Maximal zulässige Anzahl von Dateien pro Downloadvorgang – {{maxNumber}}.",
    "move company": {
      "confirmation dialog": {
        "are you sure": "Sind Sie sicher?",
        "description": "Sie sind dabei, „{{sourceCompany}}“ nach „{{targetCompany}}“ zu verschieben. Dieser Vorgang kann nicht rückgängig gemacht werden. Möchten Sie wirklich fortfahren?"
      },
      "description": "Wählen Sie ein Quellunternehmen und ein Zielunternehmen aus, unter das es verschoben werden soll. Das Quellunternehmen und seine Ressourcen werden unter das ausgewählte Zielunternehmen verschoben. Dieser Vorgang kann nicht rückgängig gemacht werden.",
      "error dialog": {
        "description": "Die maximal zulässige Anzahl von Unternehmensebenen beträgt 4. Das Verschieben des ausgewählten Unternehmens an diese Stelle würde diese Grenze überschreiten.",
        "title": "Umzug des Unternehmens nicht möglich"
      },
      "info banner": "Das Quellunternehmen behält alle seine Fahrzeuge, Fahrer, Dateien, Unternehmen, Benutzer, Integrationen und benutzerdefinierten Zeitpläne bei. Wenn auf der Ebene des Stammunternehmens ein globaler Zeitplan aktiviert ist, wird dieser nach der Migration übernommen. Ist dies nicht der Fall, bleiben die bestehenden Zeitpläne unverändert bestehen.",
      "source company": "Quellunternehmen",
      "sftp warning": "Das ausgewählte Unternehmen verfügt über einen konfigurierten, aktiven SFTP-Server. Die SFTP-Verbindung wird während der Migration des Unternehmens unterbrochen. Sobald die Migration abgeschlossen ist, wird ein neuer SFTP-Pfad erstellt und die Verbindung wiederhergestellt.",
      "target company": "Zielunternehmen",
      "title": "Umzug des Unternehmens"
    },
    "move vehicles": "Fahrzeuge bewegen",
    "move vehicles info": "Hinweis: Die Fahrzeugdateien verbleiben im aktuellen Unternehmen. Der Download-Verlauf wird gelöscht und die Download-Zeitpläne werden entfernt.",
    "name": "Name",
    "name not valid": "Der Name darf nicht mehr als {{maxNumber}} Zeichen enthalten",
    "name should not be empty": "Der Name darf nicht leer sein",
    "name too short": "Der Name muss mindestens {{minNumber}} Zeichen enthalten",
    "optional": "optional",
    "overwrite imei checkbox": {
      "description": "Diese Option entfernt die IMEI aus {{vehicleNumber}}.",
      "title": "IMEI überschreiben."
    },
    "parent company": "Muttergesellschaft",
    "password": "Passwort",
    "password cannot contain more than": "Das Passwort darf nicht mehr als {{maxNumber}} Zeichen enthalten",
    "past dates": {
      "1 month ago": "vor 1 Monat",
      "1 week ago": "vor 1 Woche",
      "1 year ago": "vor 1 Jahr",
      "multiple months ago": "vor {{monthCount}} Monaten",
      "multiple weeks ago": "vor {{weekCount}} Wochen",
      "multiple years ago": "vor {{yearCount}} Jahren",
      "today": "Heute",
      "yesterday": "Gestern"
    },
    "port": "Port",
    "port must be between": "Der Port muss zwischen den Werten {{minNumber}} und {{maxNumber}} liegen",
    "previous month": "Vorheriger Monat",
    "provider": "Provider",
    "publish news": "Nachrichten veröffentlichen?",
    "publish news description": "Diese Nachrichten sollen veröffentlicht werden. Möchten Sie wirklich fortfahren? Dieser Vorgang kann nicht rückgängig gemacht werden.",
    "publish release notes": "Release-Hinweise veröffentlichen?",
    "publish release notes description": "Die Versionshinweise sollen veröffentlicht werden. Möchten Sie wirklich fortfahren? Dieser Vorgang kann nicht rückgängig gemacht werden.",
    "release notes": "Versionshinweise",
    "remote directory path cannot contain more than": "Der Pfad zum Remote-Verzeichnis darf nicht mehr als {{maxNumber}} Zeichen enthalten",
    "remote directory path optional": "Pfad zum Remote-Verzeichnis (optional)",
    "remove": "Entfernen",
    "remove schedules": "Zeitpläne entfernen",
    "remove schedules confirmation description": {
      "drivers multiple": "Möchten Sie die Zeitpläne {{resourceValue}} wirklich von den ausgewählten Fahrern entfernen?",
      "drivers single": "Möchten Sie {{resourceValue}} wirklich aus den ausgewählten Fahrern entfernen?",
      "vehicles multiple": "Möchten Sie die Zeitpläne {{resourceValue}} wirklich aus den ausgewählten Fahrzeugen entfernen?",
      "vehicles single": "Möchten Sie {{resourceValue}} wirklich aus den ausgewählten Fahrzeugen entfernen?"
    },
    "remove schedules description": {
      "drivers": "Wählen Sie einen oder mehrere Zeitpläne aus, die Sie für die ausgewählten Fahrer entfernen möchten.",
      "vehicles": "Wählen Sie einen oder mehrere Zeitpläne aus, die Sie aus den ausgewählten Fahrzeugen entfernen möchten."
    },
    "resend invitation": "Einladung erneut senden",
    "resend invitation description": "Möchten Sie die Einladung für {{userEmail}} wirklich erneut senden?",
    "role": "Rolle",
    "schedule apply to all": {
      "drivers": "Der ausgewählte Zeitplan gilt für alle Fahrer des ausgewählten Unternehmens.",
      "vehicles": "Der ausgewählte Zeitplan wird auf alle Fahrzeuge des ausgewählten Unternehmens angewendet."
    },
    "schedule apply to filtered": {
      "drivers": "Der ausgewählte Zeitplan wird auf die Fahrer angewendet, die mithilfe eines oder mehrerer verfügbarer Filter herausgefiltert wurden.",
      "vehicles": "Der ausgewählte Zeitplan wird auf die Fahrzeuge angewendet, die mithilfe eines oder mehrerer verfügbarer Filter gefiltert wurden."
    },
    "schedule apply to selected": {
      "drivers": "Der ausgewählte Zeitplan wird auf alle Fahrer angewendet, die über das Kontrollkästchen ausgewählt wurden.",
      "vehicles": "Der ausgewählte Zeitplan wird auf alle Fahrzeuge angewendet, die über das Kontrollkästchen ausgewählt wurden."
    },
    "schedule time tooltip description": "Vergangene Zeitpunkte werden automatisch auf den nächstmöglichen Zeitpunkt in der Zukunft angepasst.",
    "security settings": "Sicherheitseinstellungen",
    "security settings description": "Verwalten Sie die Sicherheitseinstellungen Ihres Kontos.",
    "select": "Auswählen",
    "select a company": "Wählen Sie ein Unternehmen aus",
    "select file format example": "Format auswählen (z. B. .DDD)",
    "select format": "Format auswählen",
    "select image": "Bild auswählen",
    "select image description": "Bild auswählen und mit 'Speichern' bestätigen.",
    "select schedules": "Zeitpläne auswählen",
    "selected resource": "Ausgewählte {{resource}}",
    "selected drivers": "Ausgewählte Fahrer",
    "selected vehicles": "Ausgewählte Fahrzeuge",
    "selected role info message": "<3>Hier klicken</3>, um die detaillierte Berechtigungstabelle einzusehen.",
    "selected role info message title": "Die Rolle definiert die Benutzerberechtigungen in TachoSync.",
    "sftp integration": {
      "description": "Richten Sie Ihre SFTP-Verbindung ein und definieren Sie die Struktur der Tachographendateien.",
      "edit title": "SFTP-Integration bearbeiten \"{{integrationName}}\"",
      "sftp name": "SFTP-Name",
      "title": "SFTP-Integration"
    },
    "sftp password": "SFTP-Passwort",
    "sftp server hostname or ip": "Hostname oder IP-Adresse des SFTP-Servers",
    "sftp server port number": "SFTP-Server-Portnummer",
    "sftp server settings": "SFTP-Server-Einstellungen",
    "sftp username": "SFTP-Benutzername",
    "Teltonika code": "Teltonika-Code",
    "Teltonika code invalid characters": "Der Teltonika-Code muss {{minCount}}–{{maxCount}} Zeichen lang sein und darf Buchstaben, Zahlen und Punkte enthalten.",
    "Teltonika code placeholder": "Der Teltonika-Code muss {{minCount}}-{{maxCount}} Zeichen lang sein",
    "Teltonika company name": "Firmenname",
    "time": "Zeit",
    "time zone": "Zeitzone",
    "title": "Titel",
    "title not valid": "Der Titel darf nicht mehr als {{maxNumber}} Zeichen enthalten",
    "title should not be empty": "Der Titel darf nicht leer sein",
    "title too short": "Der Titel muss mindestens {{minNumber}} Zeichen enthalten",
    "to": "An",
    "toggle children global schedule linking": "Mit der Muttergesellschaft verbunden Globaler Zeitplan",
    "toggle children global schedule linking tooltip": "Der globale Zeitplan wird vom Stammunternehmen gesteuert. Deaktivieren Sie diese Option, um ihn für das ausgewählte Unternehmen individuell anzupassen. Hinweis: Die Verknüpfung zum Stammunternehmen wird dabei getrennt.",
    "toggle global schedule linking": "Globalen Zeitplan auf alle Tochtergesellschaften anwenden",
    "toggle global schedule linking tooltip": "Bei aktivierter Option gilt der globale Zeitplan für alle Tochterunternehmen. Tochterunternehmen können die Option deaktivieren, um einen eigenen globalen Zeitplan festzulegen.",
    "toggle global schedule warning banner": "Tochterunternehmen, die bereits einen eigenen globalen Zeitplan verwenden, sind davon nicht betroffen, es sei denn, sie wählen diese Option in ihren Zeitplaneinstellungen aus.",
    "unpublished release notes": "Es gibt unveröffentlichte Versionshinweise.",
    "upload folder blank for root": "Upload-Ordner (leer für Stammverzeichnis)",
    "username": "Benutzername",
    "username cannot contain more than": "Der Benutzername darf nicht mehr als {{maxNumber}} Zeichen enthalten",
    "vdo integration": {
      "add": {
        "description": "Konfigurieren Sie Ihre VDO-Flottenverbindung.",
        "title": "VDO-Flottenintegration hinzufügen"
      },
      "edit": {
        "description": "Konfigurieren Sie Ihre VDO-Flottenverbindung.",
        "title": "VDO-Flottenintegration bearbeiten"
      },
      "provider settings description": "Verwenden Sie unbedingt die von VDO Fleet bereitgestellten Zugangsdaten.",
      "provider settings title": "Anbietereinstellungen"
    },
    "vehicle folder": "Fahrzeugordner",
    "vehicle imei in use inaccessible": {
      "description": "Diese IMEI ist bereits einem Unternehmen außerhalb Ihrer Unternehmensgruppe zugewiesen. Sollte ein Gerät mit dieser IMEI Ihnen gehören, wenden Sie sich bitte an <supportLink>den Teltonika-Support</supportLink>.",
      "title": "IMEI wird von einer anderen Unternehmensgruppe verwendet"
    },
    "vehicle name": "Fahrzeugname",
    "vehicle number": "Kfz-Kennzeichen (VRN)",
    "vehicle registration number tooltip": "Die automatische Aktualisierung ist in Ihren Unternehmenseinstellungen aktiviert. Die hier eingegebene VRN wird nach dem ersten erfolgreichen Download durch den aus den Tachographendaten ausgelesenen Wert überschrieben.",
    "vehicles folder naming": "Benennung von Fahrzeugordnern",
    "vrn": "Kfz-Kennzeichen",
    "vrn should not be empty": "Das Kennzeichen darf nicht leer sein",
    "welcome to beta version title": "Willkommen beim TachoSync-Beta-Test!"
  },
  "Download history": {
    "download successful": "Download erfolgreich",
    "driver data": "Fahrerdaten",
    "no history": "Hier wird der Verlauf angezeigt",
    "schedule": "Zeitplan"
  },
  "Download monitoring": {
    "APDU packet reading error. Device disconnected.": "Fehler beim Lesen des APDU-Pakets. Gerät getrennt.",
    "Authenticating": "Authentifizierung",
    "Authentication failure (02x10)": "Authentifizierungsfehler (02x10)",
    "Authentication failure after timeout (02x01)": "Authentifizierungsfehler nach Zeitüberschreitung (02x01)",
    "Authentication failure after timeout (02x12)": "Authentifizierungsfehler nach Zeitüberschreitung (02x12)",
    "Card reading error. Please reinsert the company card, reconnect the card reader, or restart the service.": "Fehler beim Einlesen der Karte. Bitte stecken Sie die Unternehmenskarte erneut ein, schließen Sie den Kartenleser erneut an oder starten Sie den Dienst neu.",
    "CheckingCredits": "Guthaben prüfen",
    "CompanyCardExpired": "Firmenkarte abgelaufen",
    "CompanyCardInUse": "Firmenkarte im Einsatz",
    "Could not download any of files": "Es konnten keine Dateien heruntergeladen werden",
    "CreditReserved": "Rechte vorbehalten",
    "Download rejected: device VIN doesn't match this vehicle's VIN record. If the device was moved to a new vehicle, create a new vehicle record to continue.": "Download abgelehnt: Die Fahrgestellnummer des Geräts stimmt nicht mit dem Eintrag für dieses Fahrzeug überein. Wenn das Gerät in ein neues Fahrzeug eingebaut wurde, legen Sie bitte einen neuen Fahrzeugdatensatz an, um fortzufahren.",
    "DownloadingDriverData": "Herunterladen von Fahrerdaten",
    "DownloadingDriverDataFailed": "Download von Fahrerdaten fehlgeschlagen",
    "DownloadingVehicleData": "Herunterladen von Fahrzeugdaten",
    "Driver info packet reading error. Device disconnected.": "Fehler beim Auslesen des Fahrerinformationspakets. Gerät getrennt.",
    "Failed to download driver data": "Das Herunterladen der Fahrerdaten ist fehlgeschlagen",
    "Failed to receive APDU from card, timeout exceeded": "APDU von der Karte konnte nicht empfangen werden, Zeitlimit überschritten",
    "Failed to receive VUReady packet from device, timeout exceeded": "Der Empfang des VUReady-Pakets vom Gerät ist fehlgeschlagen, das Zeitlimit wurde überschritten",
    "Failed to receive VUReady packet. If problem persists, check the telematics/tacho devices setup.": "Der Empfang des VUReady-Pakets ist fehlgeschlagen. Sollte das Problem weiterhin bestehen, überprüfen Sie bitte die Konfiguration der Telematik-/Tachographen-Geräte.",
    "InsufficientCredits": "Nicht genügend Guthaben",
    "Lost connection with device or card": "Verbindung zum Gerät oder zur Karte unterbrochen",
    "NoCompanyCards": "Keine Firmenkarten",
    "NoDueSchedules": "Keine Fälligkeitstermine",
    "NoSchedulesApplied": "Es wurden keine Zeitpläne angewendet",
    "ProcessTerminated": "Vorgang beendet",
    "ReceivingDownloadList": "Empfang der Download-Liste",
    "ReceivingDriverInfo": "Empfang von Fahrerdaten",
    "ReceivingDriversSchedules": "Empfang der Fahrpläne der Fahrer",
    "ReceivingStatusState": "Empfangsstatus",
    "ReceivingVehicleSchedules": "Empfang von Fahrzeugfahrplänen",
    "requirements": {
      "company card": "Firmenkarte",
      "credits available": "Verfügbare Guthaben",
      "ignition": "Zündung",
      "ignition unavailable tooltip": "Unbekannt - der letzte bekannte Status liegt mehr als 2 Stunden zurück.",
      "imei": "IMEI",
      "schedule assigned": "Zeitplan zugewiesen",
      "vehicle activated": "Fahrzeuggesteuert",
      "reason": {
        "CompanyCardExpired": "Die Firmenkarte ist abgelaufen",
        "IgnitionNotReportedRecently": "Status unbekannt - Der Zündstatus wurde in letzter Zeit nicht gemeldet. Ein Download wird weiterhin versucht, ist jedoch weniger wahrscheinlich",
        "IgnitionOff": "Die Zündung ist ausgeschaltet. Der Download wird dennoch versucht, ist jedoch weniger wahrscheinlich",
        "InsufficientCredits": "Es sind keine Guthaben verfügbar",
        "NoCompanyCardOnline": "Derzeit ist keine Firmenkarte online",
        "NoCompanyCards": "Derzeit ist keine Firmenkarte online",
        "NoImeiAssigned": "Dem Fahrzeug ist keine IMEI zugewiesen",
        "NoScheduleAssigned": "Dem Fahrzeug muss ein Fahrplan zugewiesen sein",
        "VehicleDeactivated": "Das Fahrzeug muss aktiviert sein, um Daten herunterladen zu können"
      }
    },
    "schedules": {
      "assign schedules": "Fahrpläne zuweisen",
      "assign schedules dialog": {
        "description": "Wählen Sie einen oder mehrere Zeitpläne aus, die Sie zuweisen möchten.",
        "title": "Fahrpläne zu {{vehicleNumber}} zuweisen"
      },
      "fail reason": {
        "download requirements not met": "anforderungen für den Download wurden nicht erfüllt."
      },
      "no schedules assigned": "Für dieses Fahrzeug sind keine Fahrpläne zugewiesen",
      "on device connection": "bei Geräteverbindung",
      "requirements not met": "Der Zeitplan kann erst ausgeführt werden, wenn alle Voraussetzungen erfüllt sind."
    },
    "StageComplete": "Schritt abgeschlossen",
    "Stages": {
      "Authentication": "Authentifizierung",
      "Downloading": "Herunterladen",
      "DownloadTrigger": "Auslöser für den Download",
      "Initialization": "Initialisierung"
    },
    "Status packet reading error. Device disconnected.": "Fehler beim Lesen des Statuspakets. Gerät getrennt.",
    "TerminatingConnectionToDevice": "Verbindung zum Gerät trennen",
    "Timeout. Response from VU not received (02x01)": "Zeitüberschreitung. Keine Antwort von der Fahrzeugeinheit erhalten (02x01)",
    "Too many KeepAlive packets received.": "Es wurden zu viele KeepAlive-Pakete empfangen.",
    "Unexpected error": "Unerwarteter Fehler",
    "Unexpected loss of connection with the device. Once device returns to normal connectivity, download will continue.": "Unerwarteter Verbindungsabbruch zum Gerät. Sobald die Verbindung zum Gerät wiederhergestellt ist, wird der Download fortgesetzt.",
    "UploadingDriverFiles": "Hochladen von Fahrerdateien",
    "UploadingDriverFilesFailed": "Das Hochladen der Fahrerdateien ist fehlgeschlagen",
    "UploadingVehicleFiles": "Hochladen von Fahrzeugdateien",
    "UploadingVehicleFilesFailed": "Das Hochladen der Fahrzeugdateien ist fehlgeschlagen",
    "VehicleDeactivated": "Fahrzeug deaktiviert",
    "VuNotReady": "Fahrzeug-ID noch nicht bereit. Wiederholungsversuch in 5 Minuten",
    "VU ready packet reading error. Device disconnected.": "Fehler beim Einlesen des VU-fähigen Pakets. Gerät getrennt.",
    "WaitingForDeviceConnection": "Warten auf Geräteverbindung",
    "Wrong communication command": "Falscher Kommunikationsbefehl"
  },
  "Drivers": {
    "drivers page": "Fahrer",
    "last activity": {
      "Available": "Verfügbar",
      "BreakOrRest": "Pause/Ruhezeit",
      "Drive": "Fahren",
      "NotAvailable": "Nicht verfügbar",
      "Undefined": "k. A.",
      "Unknown": "Unbekannt",
      "Unknown4": "Unbekannt",
      "Unknown5": "Unbekannt",
      "Work": "Arbeit"
    }
  },
  "Dropzone": {
    "add file": "Datei hinzufügen",
    "drop file to upload": "Datei hier per Drag & Drop ablegen",
    "drop files to upload": "Dateien zum Hochladen ablegen",
    "error uploading the file": "Beim Hochladen der Datei ist ein Fehler aufgetreten",
    "file invalid type": "Ungültiger Dateityp ausgewählt.",
    "file successfully uploaded": "Datei erfolgreich hochgeladen",
    "file syntax": "Die Dateisyntax lautet wie folgt:",
    "maximum file limit reached": "Das maximale Dateilimit wurde erreicht.",
    "no image": "Kein Bild",
    "only one file can be attached": "Es kann nur eine Datei angehängt werden.",
    "or drop file to upload": "Oder Datei zum Hochladen ablegen",
    "or drop files to upload": "Datei hier per Drag & Drop ablegen, um sie hochzuladen",
    "row limit exceeded": "Das Limit für den Import von Ressourcen wurde erreicht. Sie können nicht mehr als {{rowLimit}} Ressourcen importieren.",
    "rows detected": "Zeilen in der Datei erfolgreich erkannt",
    "select file": "Datei auswählen",
    "select file type": "Bitte wählen Sie zunächst den Dateityp aus.",
    "select files": "Dateien auswählen",
    "select image": "Bild auswählen:",
    "supported formats": "Unterstützte Formate",
    "too long file name": "Der Dateiname ist zu lang. Maximal {{maxLength}} Zeichen sind zulässig.",
    "too many files description": "Weitere Dateien können nach Abschluss des aktuellen Uploads hinzugefügt werden.",
    "too many files title": "Es gibt eine maximale Dateibegrenzung von {{maxFiles}}, die Sie auf einmal anhängen können."
  },
  "Error": {
    "error": "Fehler",
    "message wait": "Bitte haben Sie noch etwas Geduld, bis wir den Fehler behoben haben.",
    "title": "Es ist ein Fehler aufgetreten!"
  },
  "Files": {
    "files header info tooltip": "Heruntergeladene Dateien werden zwei Jahre lang in TachoSync gespeichert und anschließend automatisch aus dem System gelöscht."
  },
  "Filter": {
    "company": "Unternehmen",
    "credit status": "Bonität",
    "deactivatedVehicles": "Deaktivierte Fahrzeuge",
    "device imei": "Geräte-IMEI",
    "device status": "Gerätestatus",
    "driver": "Fahrer",
    "filtered by": "Gefiltert nach",
    "filters used": "Verwendete Filter",
    "from to date": "{{fromDate}} bis {{toDate}}",
    "last activity": "Letzte Aktivität",
    "last download": "Letzter Download",
    "last download options": {
      "DueSoon": "In Kürze verfügbar",
      "NoDownloads": "Keine Downloads",
      "OnTime": "Pünktlich",
      "Overdue": "Überfällig",
      "Undefined": "k. A."
    },
    "more filters": "Weitere Filter",
    "noDeviceImei": "Keine Geräte-IMEI",
    "Not reserved": "Nicht reserviert",
    "Reserved": "Reserviert",
    "schedule": "Zeitplan",
    "schedule name": "Name des Zeitplans",
    "schedules": "Zeitpläne",
    "select date": "Datum auswählen",
    "select date and time": "Datum und Uhrzeit auswählen",
    "Select date range": "Datumsbereich auswählen",
    "status": "Status",
    "table filters": "Tabellenfilter",
    "vehicle number": "Fahrzeugnummer"
  },
  "General": {
    "Active": "Aktiv",
    "Administrator": "Administrator",
    "administrator role description": "Volle Kontrolle über das Erstellen, Bearbeiten und Löschen aller Ressourcen.",
    "analysis provider": "Analyseanbieter",
    "analysis providers": "Analyseanbieter",
    "api credential": "API-Anmeldedaten",
    "api credentials": "API-Anmeldedaten",
    "Available": "Verfügbar",
    "Awaiting connection": "Warte auf Verbindung",
    "badge": {
      "connected badge tooltip text": "Verbindung zu TachoSync erfolgreich hergestellt und Kommunikation gestartet.",
      "deactivated badge tooltip text": "Dieses Fahrzeug ist deaktiviert und verbraucht keine Credits.",
      "inactive badge tooltip text": "Es wurde noch nie eine erfolgreiche Verbindung mit TachoSync hergestellt.",
      "offline badge tooltip text": "In den letzten 24 Stunden keine Verbindung zu TachoSync hergestellt",
      "online badge tooltip text": "In den letzten 24 Stunden online"
    },
    "Blocked": "Gesperrt",
    "BreakOrRest": "Pause/Ruhezeit",
    "business": "Geschäft",
    "code expired": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
    "column": "Spalte",
    "companies": "Unternehmen",
    "company": "Unternehmen",
    "Company administrator": "Unternehmensadministrator",
    "Connected": "Verbunden",
    "credits": "Guthaben",
    "dashboard": "Dashboard",
    "Deactivated": "Deaktiviert",
    "Description": "Beschreibung",
    "Disabled": "Deaktiviert",
    "Disconnected": "Nicht verbunden",
    "Drive": "Fahrt",
    "driver data": "Fahrerdaten",
    "drivers": "Fahrer",
    "DueSoon": "In Kürze verfügbar",
    "end": "Ende",
    "Expired": "Abgelaufen",
    "Failed": "Fehlgeschlagen",
    "files": "Dateien",
    "here": "hier",
    "history": "Verlauf",
    "Inactive": "Inaktiv",
    "in progress": "wird gerade durchgeführt",
    "integration": "Integration",
    "integrations": "Integrationen",
    "integrations/analysisProviders": "Analyseanbieter",
    "integrations/apicredentials": "API-Anmeldedaten",
    "Interrupted": "Unterbrochen",
    "InvalidConfiguration": "Fehlgeschlagen",
    "invitations": "Einladungen",
    "latest version": "Aktuelle Version",
    "menu": "Menü",
    "NoDownloads": "Keine Downloads",
    "not assigned": "Nicht zugewiesen",
    "Not reserved": "Nicht reserviert",
    "NotAvailable": "Nicht verfügbar",
    "NotReserved": "Nicht reserviert",
    "Offline": "Offline",
    "Online": "Online",
    "OnTime": "Pünktlich",
    "Pending": "In Bearbeitung",
    "requirements": "Anforderungen",
    "Reserved": "Reserviert",
    "row": "Zeile",
    "schedule": "Zeitplan",
    "schedules": "Zeitpläne",
    "show older": "Ältere anzeigen",
    "start": "Start",
    "Successful": "Erfolgreich",
    "Teltonika support": "Teltonika-Support",
    "Teltonika Support": "Teltonika-Support",
    "teltonika support role description": "Spezieller Zugang für den technischen Support.",
    "Tooltip": {
      "accept beta terms": "Um fortzufahren, scrollen Sie nach unten und akzeptieren Sie die Bedingungen."
    },
    "unauthorized": "Benutzer konnte nicht authentifiziert werden",
    "Undefined": "k. A.",
    "Unknown": "Unbekannt",
    "Unknown4": "Unbekannt",
    "Unknown5": "Unbekannt",
    "User": "Benutzer",
    "user role description": "Basiszugang mit eingeschränkten Berechtigungen.",
    "users": "Benutzer",
    "vehicles": "Fahrzeuge",
    "Work": "Arbeit",
    "year": "Jahr"
  },
  "Languages": {
    "english": "Englisch",
    "french": "Französisch",
    "language": "Sprache"
  },
  "Navigation": {
    "collapse menu": "Menü ausblenden",
    "expand menu": "Menü erweitern"
  },
  "News": {
    "create news": "Beitrag erstellen",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "publish": "Veröffentlichen",
    "unpublished": "Unveröffentlicht"
  },
  "Notifications": {
    "notifications": "Benachrichtigungen"
  },
  "Password": {
    "account password": "Konto-Passwort",
    "are you sure": "Sind Sie sicher?",
    "change": "Ändern",
    "change password": "Passwort ändern",
    "click to scan code": "Klicken Sie hier, um stattdessen einen QR-Code zu scannen",
    "click to type code": "Klicken Sie hier, um den Code stattdessen manuell einzugeben",
    "disable description confirmation": "Sie sind dabei, die Zwei-Faktor-Authentifizierung zu deaktivieren. Dadurch wird Ihr TachoSync-Konto weniger sicher. Möchten Sie wirklich fortfahren?",
    "disable description send code": "Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App unten ein.",
    "disable description send password": "Bitte bestätigen Sie Ihre Identität mit Ihrem aktuellen Passwort.",
    "disable no access": "Haben Sie keinen Zugriff mehr auf Ihre Authenticator-App, können Sie die Zwei-Faktor-Authentifizierung nur durch eine Passwortänderung deaktivieren.",
    "disabled": "Deaktiviert",
    "disabled two FA": "Zwei-Faktor-Authentifizierung erfolgreich deaktiviert.",
    "enabled": "Aktiviert",
    "enter": "Eingeben",
    "enter current password": "Aktuelles Passwort eingeben",
    "generate key description": "Zum Abschluss benötigen Sie eine Authenticator-App auf Ihrem Mobilgerät, zum Beispiel eine der folgenden:",
    "incorrect code": "Falscher Code",
    "incorrect password": "Falsches Passwort",
    "lowercase letter": "Mindestens ein Kleinbuchstabe (a–z)",
    "minimum characters": "Mindestens {{maxNumber}} Zeichen",
    "minimum digits": "Mindestens eine Zahl",
    "password": "Passwort",
    "password too long": "Das Passwort darf nicht mehr als {{maxNumber}} Zeichen enthalten",
    "passwords must match": "Die Passwörter stimmen nicht überein.",
    "reset password success": "Ihr Passwort wurde geändert.",
    "scan QR code": "Scannen Sie den QR-Code in Ihre App",
    "six digit code": "Von Ihrer App generierter 6-stelliger Code",
    "special character": "Mindestens ein Sonderzeichen (!@#$%^&*()-_=+)",
    "success description": "Sie haben die Zwei-Faktor-Authentifizierung erfolgreich aktiviert.",
    "two-factor authentication": "Zwei-Faktor-Authentifizierung",
    "two-factor authentication description": "Die Zwei-Faktor-Authentifizierung schützt Ihr Konto durch zwei Sicherheitsstufen: Ihr Passwort und ein physisches Gerät wie Ihr Telefon oder einen Sicherheitsschlüssel.",
    "two-factor authentication enabled": "Zwei-Faktor-Authentifizierung erfolgreich aktiviert.",
    "two-factor authentication status": "Zwei-Faktor-Authentifizierung ist:",
    "type text code": "Geben Sie den Textcode in Ihre App ein",
    "uppercase letter": "Mindestens ein Großbuchstabe (A–Z)"
  },
  "Schedules": {
    "activities from": "Aktivitäten aus",
    "activities to": "Aktivitäten zu",
    "apply button tooltip": "Bitte mindestens einen {{resourceName}} auswählen, um fortzufahren.",
    "confirm bulk quick schedule": "Für die ausgewählten Fahrer wird ein Schnellplan erstellt. Möchten Sie fortfahren?",
    "confirm close": {
      "description": {
        "drivers": {
          "not selected": "Für die ausgewählten Fahrer wurde noch kein Zeitplan festgelegt. Möchten Sie wirklich fortfahren?",
          "selected": "Sie haben einen Zeitplan ausgewählt, ihn aber nicht angewendet. Möchten Sie den Zeitplan auf die ausgewählten Fahrer anwenden?"
        },
        "vehicles": {
          "not selected": "Sie haben Fahrzeuge ausgewählt, aber es wurde noch kein Zeitplan ausgewählt oder angewendet. Möchten Sie wirklich fortfahren?",
          "selected": "Sie haben einen Zeitplan ausgewählt, ihn aber nicht angewendet. Möchten Sie den Zeitplan auf die ausgewählten Fahrzeuge anwenden?"
        }
      },
      "title": {
        "not selected": "Es wurde kein Zeitplan ausgewählt oder angewendet.",
        "selected": "Zeitplan nicht angewendet."
      }
    },
    "confirm delete": {
      "description": {
        "drivers": "Möchten Sie den Zeitplan „{{scheduleName}}“ wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden und betrifft alle Fahrer, für die dieser Zeitplan gilt.",
        "vehicles": "Möchten Sie den Zeitplan „{{scheduleName}}“ wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden und wirkt sich auf alle Fahrzeuge aus, für die dieser Zeitplan gilt."
      },
      "title": "Zeitplan löschen?"
    },
    "create new schedule": "Neuen Zeitplan erstellen",
    "data types": "Datentypen",
    "days": "Tage",
    "details remove schedule": {
      "description": "Möchten Sie den Zeitplan „{{scheduleName}}“ wirklich löschen?",
      "title": "Zeitplan entfernen?"
    },
    "download activities": {
      "date info tooltip": "Der Zeitraum der Aktivität muss mindestens zwei Tage umfassen.",
      "tooltip text": "TachoSync passt den Download-Zeitraum automatisch auf Basis des letzten erfolgreichen Datenabrufs an. So werden Lücken vermieden und die Datenkontinuität gewährleistet, auch wenn ein geplanter Download mehrere Tage ausbleibt."
    },
    "driver number": "Fahrer {{driverNum}}",
    "driver schedules": {
      "description": "Mit Zeitplänen automatisieren Sie den Download von Tachographendaten für ausgewählte Fahrer. Wählen Sie die gewünschten Fahrer und einen Zeitplan aus der Liste aus und klicken Sie auf 'Übernehmen', um ihn zu aktivieren. Zeitpläne können jederzeit erstellt, bearbeitet und gelöscht werden. Hinweis: Pro Unternehmen sind maximal 3 gleichzeitige Zeitpläne möglich.",
      "description read-only": "Mit Zeitplänen automatisieren Sie den Download von Tachographendaten für ausgewählte Fahrer. Unternehmensadministratoren können Zeitpläne jederzeit erstellen, bearbeiten und löschen.",
      "title": "Fahrerzeitpläne"
    },
    "due date": "Fälligkeitsdatum",
    "edit schedule": {
      "description": {
        "drivers": {
          "global": "Der globale Zeitplan wird automatisch auf alle neu hinzugefügten Fahrer angewendet. Dies kann in den allgemeinen Einstellungen geändert werden.",
          "not global": "Änderungen an diesem Zeitplan wirken sich auf alle Fahrer aus, denen dieser Zeitplan zugewiesen ist."
        },
        "vehicles": {
          "global": "Der globale Zeitplan wird automatisch auf alle neu hinzugefügten Fahrzeuge angewendet. Dies kann in den allgemeinen Einstellungen geändert werden.",
          "not global": "Dieser Zeitplan gilt für mehrere Fahrzeuge. Änderungen wirken sich auf alle betroffenen Fahrzeuge aus."
        }
      },
      "title": {
        "global": "Globaler Zeitplan",
        "not global": "Zeitplan bearbeiten"
      }
    },
    "enter days": "Tage eingeben",
    "every": "Jedes",
    "fail reason": "Fehlerursache",
    "file types": {
      "Activities": "Aktivitäten",
      "DetailedSpeed": "Geschwindigkeitsdetails",
      "EventsAndFaults": "Ereignisse und Fehler",
      "Overview": "Übersicht",
      "TechnicalData": "Technische Daten"
    },
    "global schedule": {
      "connected to root company": "Mit dem globalen Zeitplan des Stammunternehmens verknüpft.",
      "global icon info": "Der globale Zeitplan wird automatisch auf alle neu registrierten {{specificGlobalSchedule}} angewendet. Sie können diese Option in den Unternehmenseinstellungen deaktivieren.",
      "info": {
        "edit driver schedule": "Der globale Zeitplan gilt automatisch für alle neu registrierten Fahrer. Sie können diese Option in den Unternehmenseinstellungen deaktivieren.",
        "edit schedule": "Der globale Zeitplan gilt automatisch für alle neu registrierten {{ variableName }}. Sie können diese Option in den Unternehmenseinstellungen deaktivieren.",
        "edit vehicle schedule": "Der globale Zeitplan gilt automatisch für alle neu registrierten Fahrzeuge. Sie können diese Option in den Unternehmenseinstellungen deaktivieren."
      },
      "inherited settings": "Alle Tochterunternehmen übernehmen automatisch den globalen Zeitplan des Stammunternehmens.",
      "not configured description": "Klicken Sie auf 'Bearbeiten', um den globalen Zeitplan zu konfigurieren.",
      "not configured description read-only": "Die Details des Zeitplans werden angezeigt, sobald dieser konfiguriert ist.",
      "not configured title": "Globaler Zeitplan nicht konfiguriert.",
      "not connected to root company": "Nicht mit dem globalen Zeitplan des Stammunternehmens verbunden."
    },
    "include driver data": "Fahrerdaten einbeziehen",
    "include driver data tooltip": "Legen Sie fest, ob der Schnellplan auch Fahrerkartendaten herunterladen soll, wenn zum Zeitpunkt der Ausführung eine Karte im Tachographen eingelegt ist.\n<ul><li>Keine – Es werden ausschließlich Fahrzeugeinheitsdaten (VU) heruntergeladen.</li><li>Fahrer 1 / Fahrer 2 – Daten aus dem gewählten Steckplatz werden heruntergeladen, sofern eine Fahrerkarte eingelegt ist.</li><li>Beide Fahrer – Daten beider Steckplätze werden heruntergeladen, sofern Karten eingelegt sind.</li></ul>Ist zum Zeitpunkt der Ausführung keine Fahrerkarte im gewählten Steckplatz eingelegt, werden keine Fahrerdaten heruntergeladen.",
    "max number reached": "Sie haben die maximal zulässige Anzahl an Zeitplänen erreicht.",
    "name not valid": "Der Name des Zeitplans darf nicht mehr als {{maxNumber}} Zeichen enthalten",
    "next attempt": "Nächster Versuch",
    "next date": "Nächster Termin",
    "next date and time": "Nächstes Datum und Uhrzeit",
    "next due date": "Nächster Fälligkeitstermin",
    "quick schedule": {
      "description": "Wählen Sie aus, welche Datentypen heruntergeladen werden sollen.",
      "driver schedule quick download new": "Erstellt einen einmaligen Zeitplan für den Download von Fahrerdateien. Dieser wird ausgeführt, sobald der Fahrer eine Verbindung zur Anwendung herstellt.",
      "info banner": {
        "drivers": "Dies ist ein einmaliger Zeitplan. Der Download der Fahrerdaten wird gestartet, sobald die Verbindung des Fahrers zu TachoSync erkannt wird.",
        "vehicles": "Dies ist ein einmaliger Zeitplan. Der Download der Fahrzeugdaten wird gestartet, sobald eine Verbindung des Fahrzeugs zu TachoSync festgestellt wird."
      },
      "success banner": "Der Zeitplan wurde abgeschlossen und kann durch Klicken auf „Zeitplan entfernen“ gelöscht werden",
      "title": "Schnellübersicht",
      "vehicle schedule quick download deactivated": "Der Schnellplan kann bei deaktivierten Fahrzeugen nicht gestartet werden. Wenn Sie einen neuen Schnellplan starten möchten, aktivieren Sie zunächst das Fahrzeug.",
      "vehicle schedule quick download new": "Erstellt einen einmaligen Zeitplan für den Download von Fahrzeugdateien. Dieser wird ausgeführt, sobald das Fahrzeug eine Verbindung zur Anwendung herstellt."
    },
    "repeat": "Wiederholen",
    "repeat every": "Wiederholen alle",
    "repeat period": {
      "Biweekly": "Alle 14 Tage",
      "Custom": "Benutzerdefiniert",
      "Daily": "Täglich",
      "Every28Days": "Alle 28 Tage",
      "Every90Days": "Alle 90 Tage",
      "EveryDays": "Alle {{count}} Tage",
      "Hourly": "Stündlich",
      "Monthly": "Monatlich",
      "Weekly": "Alle 7 Tage"
    },
    "schedule details": "Details zu „{{scheduleName}}“",
    "select date": "Datum auswählen",
    "start date": "Startdatum",
    "start date and time": "Startdatum und -zeit",
    "vehicle schedules": {
      "description": "Mit Fahrzeugzeitplänen automatisieren Sie den Download von Tachographendaten für ausgewählte Fahrzeuge. Wählen Sie die gewünschten Fahrzeuge und einen Zeitplan aus der Liste aus und klicken Sie auf 'Übernehmen', um ihn zu aktivieren. Zeitpläne können jederzeit erstellt, bearbeitet und gelöscht werden. Hinweis: Pro Unternehmen sind maximal 3 gleichzeitige Fahrzeugzeitpläne möglich.",
      "description read-only": "Mit Fahrzeugzeitplänen automatisieren Sie den Download von Tachographendaten für ausgewählte Fahrzeuge. Unternehmensadministratoren können Zeitpläne jederzeit erstellen, bearbeiten und löschen.",
      "download data activities tooltip hourly": "Die Aktivitäten des aktuellen Tages werden heruntergeladen",
      "download data activities tooltip monthly": "Es werden jeweils die Aktivitäten des gesamten Vormonats vor dem Ausführungsdatum heruntergeladen.",
      "download data activities tooltip multiple": "Es werden jeweils die Aktivitäten der letzten {{repeatDays}} Tage vor dem Ausführungsdatum heruntergeladen.",
      "download data activities tooltip single": "Es werden jeweils die Aktivitäten des letzten Tages vor dem Ausführungsdatum heruntergeladen.",
      "title": "Fahrzeugzeitpläne"
    }
  },
  "Search": {
    "find device": {
      "error not valid": "Die IMEI muss aus 15 Zeichen bestehen",
      "find device": "Gerät suchen",
      "no vehicle found": "Kein Fahrzeug gefunden",
      "no vehicle found description": "Fahrzeug nicht gefunden. Bitte geben Sie eine andere IMEI-Nummer ein.",
      "only numbers": "Es sind nur Zahlen zulässig",
      "search for vehicles by their IMEI": "Suche nach Fahrzeugen anhand der IMEI-Nummer des Geräts",
      "search vehicle IMEI": "IMEI des Geräts suchen"
    },
    "search": "Suchen...",
    "search child company": "Tochtergesellschaft suchen",
    "search company name": "Nach Firmennamen suchen",
    "search in driverFiles": "Suche nach Fahrer oder Fahrer-ID",
    "search in drivers": "Suche nach Name oder Fahrer-ID",
    "search in integrations": "Suche nach Name",
    "search in users": "Suche per E-Mail",
    "search in vehicleFiles": "Suche nach IMEI oder Kfz-Kennzeichen des FM-Geräts",
    "search in vehicles": "Suche nach IMEI oder Kfz-Kennzeichen des FM-Geräts"
  },
  "Security": {
    "2FA": {
      "get email code": {
        "description": "Geben Sie diesen Code im nächsten Schritt ein, um Ihr Konto zu bestätigen.",
        "description modal": "Verwenden Sie diesen Code, um Ihr Konto zu verifizieren.",
        "title": "Wenn Sie auf „Code senden“ klicken, wird ein einmaliger Code an <1>{{email}} gesendet</1>."
      },
      "select authentication type": {
        "authentication app description": "Einmalcode über eine Authenticator-App wie Microsoft Authenticator oder Google Authenticator abrufen.",
        "description": "Um die Sicherheit Ihres Kontos und Ihrer Kundendaten zu gewährleisten, nutzen Sie bitte eine der folgenden Optionen, um die Zwei-Faktor-Authentifizierung einzurichten.",
        "description modal": "Wählen Sie Ihre bevorzugte Authentifizierungsmethode aus.",
        "email": "E-Mail",
        "email description": "Bei jeder Anmeldung erhalten Sie einen Einmalcode per E-Mail.",
        "recommended": "Empfohlen",
        "title": "Die Zwei-Faktor-Authentifizierung (2FA) ist für alle TachoSync-Benutzer verpflichtend.",
        "title modal": "Authentifizierungsmethode auswählen"
      },
      "send email code": {
        "description": "Bitte geben Sie den Code in das untenstehende Feld ein und klicken Sie auf „Überprüfen“, um fortzufahren.",
        "enter code": "Bitte geben Sie den Code ein, um die E-Mail-Adresse zu bestätigen.",
        "title": "Ein einmaliger Code wurde an <1>{{email}} gesendet</1>.",
        "verification code": "Bestätigungscode"
      },
      "send otp code": {
        "click to scan code": "Klicken Sie hier, um stattdessen einen QR-Code zu scannen",
        "click to type code": "Klicken Sie hier, um den Code stattdessen manuell einzugeben",
        "incorrect code": "Falscher Code",
        "scan QR code": "Scannen Sie den QR-Code in Ihre App",
        "six digit code": "Von Ihrer App generierter 6-stelliger Code",
        "title": "Für diesen Schritt benötigen Sie eine Authenticator-App auf Ihrem Mobilgerät, zum Beispiel: <1>Microsoft Authenticator</1> oder <2>Google Authenticator</2>.",
        "type text code": "Geben Sie den Textcode in Ihre App ein"
      },
      "success message": {
        "alert": "Zwei-Faktor-Authentifizierung erfolgreich aktiviert.",
        "description": "Nach jeder Anmeldung mit E-Mail und Passwort ist ein zusätzlicher Authentifizierungscode erforderlich.",
        "title": "Sie haben die Zwei-Faktor-Authentifizierung erfolgreich aktiviert.",
        "title modal": "Zwei-Faktor-Authentifizierung aktiviert!"
      },
      "title": {
        "authentication app": "Authentifizierungs-App",
        "authentication email": "Bestätigungs-E-Mail",
        "is enabled": "Zwei-Faktor-Authentifizierung aktiviert.",
        "protect your account": "Schützen Sie Ihr TachoSync-Konto"
      }
    }
  },
  "Selector": {
    "client company": "Kundenunternehmen",
    "companies": "Unternehmen ({{companyCount}})",
    "company selector": "Unternehmensauswahl"
  },
  "Settings": {
    "CCA file size": "Dateigröße 83,5 MB",
    "change password": "Passwort ändern",
    "company card authenticator": "Unternehmenskarten-Authentifikator",
    "email notifications": {
      "credits purchased": "Erworbene Guthaben",
      "low credits alerts": "Benachrichtigungen bei niedrigem Guthaben",
      "title": "E-Mail-Benachrichtigungen",
      "tooltip": "Legen Sie fest, welche E-Mails zum Thema Kredit Sie erhalten möchten."
    },
    "feature switches": "Funktionsschalter",
    "file format settings": {
      "description": "Legen Sie fest, in welchem Format Tachographendateien gespeichert werden sollen. Verfügbare Formate: europäisch (.DDD), französisch (.V1B für Fahrzeugdaten, .C1B für Fahrerdaten) und spanisch (.TGD).",
      "title": "Einstellungen für Dateiformate"
    },
    "file formats": {
      "DDD": ".DDD",
      "TGD": ".TGD",
      "V1BC1B": ".V1B, .C1B"
    },
    "general settings": "Allgemeine Einstellungen",
    "security": "Sicherheit",
    "time settings": {
      "date display format tooltip": "Wählen Sie ein Format für die Anzeige des Datums in TachoSync aus.\nBeispiel: TT-MM-JJJJ = 14-05-2024",
      "description": "Lassen Sie die Zeitzone automatisch anhand Ihres Standorts ermitteln oder wählen Sie manuell Ihre bevorzugte Zeitzone und das Anzeigeformat für Zeitstempel.",
      "time and date format toggle": "Zeit- und Datumsformat automatisch einstellen",
      "title": "Zeiteinstellungen"
    },
    "tutorials": "Anleitungen",
    "version": "Version"
  },
  "Table": {
    "activity period": "Aktivitätszeitraum",
    "Automatic initial Driver Download": "Automatischer erster Fahrer-Download",
    "Automatic initial Vehicle Download": "Automatischer erster fahrzeug-download",
    "card name": "Name",
    "card number": "Fahrer-ID",
    "cardnumber": "Fahrer-ID",
    "comment": "Kommentar",
    "company": "Unternehmen",
    "connection status": "Verbindungsstatus",
    "created at": "Erstellt am",
    "created by": "Erstellt von",
    "credit status": "Bonität",
    "data types": "Datentypen",
    "day ago": "vor 1 Tag",
    "days ago": "vor {{daysNum}} Tagen",
    "description": "Beschreibung",
    "device imei": "Geräte-IMEI",
    "device imei empty": "Für das Fahrzeug wurde keine IMEI hinzugefügt. Eine gültige IMEI ist für die Geräteverbindung und den Dateidownload erforderlich. Gehen Sie zu „Fahrzeug bearbeiten“ und fügen Sie eine gültige IMEI hinzu, um den Download von Fahrzeugdateien zu ermöglichen.",
    "device status": "Gerätestatus",
    "downloaded at": "Heruntergeladen am",
    "driver": "Fahrer",
    "driver name": "Name des Fahrers",
    "drivers name": "Name des Fahrers",
    "email": "E-Mail",
    "empty table": {
      "button": {
        "add": {
          "analysis providers": "Integration hinzufügen",
          "driver files": "Fahrerdatei hinzufügen",
          "drivers": "Fahrer hinzufügen",
          "integrations": "Integration hinzufügen",
          "integrations api": "Integration hinzufügen",
          "users": "Benutzer einladen",
          "vehicle files": "Fahrzeugdatei hinzufügen",
          "vehicles": "Fahrzeug hinzufügen"
        },
        "reset view": "Ansicht zurücksetzen"
      },
      "no initial results": {
        "description": {
          "analysis providers": "Sobald Analyseanbieter zu TachoSync hinzugefügt werden, \nkönnen Sie die Liste hier einsehen.",
          "companies": "Hinzugefügte Unternehmen werden hier angezeigt.",
          "company cards": "Hinzugefügte Firmenkarten werden hier angezeigt.",
          "driver files": "Hinzugefügte Fahrerdateien werden hier angezeigt.",
          "drivers": "Hinzugefügte Fahrer werden hier angezeigt.",
          "integrations": "Hinzugefügte Integrationen werden hier angezeigt.",
          "integrations api": "Erstellte API-Schlüssel werden hier angezeigt.",
          "users": "Hinzugefügte Benutzer werden hier angezeigt.",
          "users invitations": "Eingeladene Benutzer werden hier angezeigt.",
          "vehicle files": "Hinzugefügte Fahrzeugdateien werden hier angezeigt.",
          "vehicles": "Hinzugefügte Fahrzeuge werden hier angezeigt."
        },
        "title": {
          "analysis providers": "Noch keine Analyseanbieter",
          "companies": "Die Tabelle „Unternehmen“ ist leer",
          "company cards": "Die Tabelle mit den Firmenkarten ist leer",
          "driver files": "Die Tabelle mit den Fahrerdateien ist leer",
          "drivers": "Die Fahrertabelle ist leer",
          "integrations": "Noch keine Integrationen",
          "integrations api": "Noch keine API-Schlüssel",
          "users": "Die Benutzertabelle ist leer",
          "users invitations": "Die Tabelle mit den Benutzereinladungen ist leer",
          "vehicle files": "Die Tabelle mit den Fahrzeugdateien ist leer",
          "vehicles": "Die Fahrzeugtabelle ist leer"
        }
      },
      "no results found": {
        "description": "Probieren Sie ein anderes Stichwort oder einen anderen Filter aus, um weitere \nErgebnisse zu erhalten.",
        "title": "Keine Ergebnisse gefunden"
      }
    },
    "enable": "Aktivieren",
    "expiration date": "Ablaufdatum",
    "expired integration tooltip": "Die Integration ist abgelaufen und kann nicht aktiviert werden",
    "file name": "Dateiname",
    "Global schedule": "Globaler Zeitplan",
    "imei": "IMEI",
    "invitation status": "Einladungsstatus",
    "invited at": "Eingeladen am",
    "invited by": "Eingeladen von",
    "last activity": "Letzte Aktivität",
    "last connected": "Zuletzt verbunden",
    "last connection": "Letzte Verbindung",
    "last download": "Letzter Download",
    "last download date": "Letzter Download: {{date}}",
    "last event": "Letztes Ereignis",
    "last vehicle used": "Zuletzt genutztes Fahrzeug",
    "method": "Methode",
    "name": "Name",
    "next download": "Nächster Download",
    "No schedule applied": "Kein Zeitplan angewendet",
    "No schedules": "Keine Zeitpläne",
    "number": "Anzahl",
    "Overdue": "Überfällig",
    "parent company": "Muttergesellschaft",
    "plate number": "Kennzeichen",
    "provider": "Provider",
    "Quick schedule": "Schnellzeitplan",
    "role": "Rolle",
    "rows per page": "Zeilen pro Seite",
    "schedule": "Zeitplan",
    "schedules": "Zeitpläne",
    "seen at": "Zuletzt gesehen",
    "select columns to show": "Spalten zum Anzeigen auswählen",
    "show details": {
      "companies": "Unternehmensdetails anzeigen",
      "drivers": "Fahrerdaten anzeigen",
      "integrations": "Integrationsdetails anzeigen",
      "vehicles": "Fahrzeugdetails anzeigen"
    },
    "status": "Status",
    "today": "Heute",
    "updated at": "Aktualisiert am",
    "vehicle": "Fahrzeug",
    "vehicle name": "Fahrzeugname",
    "vehicle number": "Kfz-Kennzeichen",
    "vehicles": "Fahrzeuge"
  },
  "Tabs": {
    "analysis providers": "Analyseanbieter",
    "api": "API",
    "invitations": "Einladungen",
    "sftp": "SFTP",
    "users": "Benutzer"
  },
  "Tooltip": {
    "delete company action": "Unternehmen mit Tochterunternehmen können nicht gelöscht werden. Bitte zuerst alle Tochterunternehmen entfernen.",
    "no action permission": "Sie haben keine Berechtigung für diese Aktion",
    "parent company": "Die maximale Strukturtiefe von {{maxAllowedLevels}} Ebenen ist erreicht. '{{companyName}}' befindet sich auf der untersten Ebene und kann keine Tochterunternehmen mehr erhalten."
  },
  "Tutorials": {
    "add company card": {
      "desktop": {
        "fifth step": {
          "content": "Um eine neue Firmenkarte hinzuzufügen, klicken Sie auf die hervorgehobene Schaltfläche „Neu<strong> </strong>hinzufügen“. Wenn der Bildschirm zum Hinzufügen einer Firma angezeigt wird, füllen Sie die erforderlichen Felder aus und klicken Sie zum Abschluss auf die Schaltfläche „Speichern“.\n\nHinweis: Die Firmenkarten-ID finden Sie im Firmenkarten-Authentifikator in der Spalte „Karten-ID“.\n\nKlicken Sie auf „Weiter“, um fortzufahren.",
          "title": "Neue Firmenkarte hinzufügen"
        },
        "final step": {
          "content": "Alle hinzugefügten Karten und deren Details werden unter „Firmenkarten“ aufgelistet.\n\nHinweis: Sie können dieses Tutorial jederzeit wiederholen, indem Sie zu „Einstellungen“ – „Tutorials“ gehen. \n\nKlicken Sie auf <strong>„Fertigstellen</strong>“, um das Tutorial abzuschließen.",
          "title": "Angaben zur Firmenkarte"
        },
        "first step": {
          "content": "Bevor Sie eine Unternehmenskarte in TachoSync hinzufügen, stellen Sie sicher, dass Sie den Company Card Authenticator heruntergeladen und installiert haben. Dies können Sie jederzeit über das Menü „Einstellungen“ tun.\n\nDer Company Card Authenticator liest die Informationen von den in Ihren Kartenleser eingelegten Unternehmenskarten aus und zeigt sie an und ermöglicht die Fernauthentifizierung.\n\nKlicken Sie auf<strong> </strong>„<strong>Loslegen</strong>“, um zu beginnen.",
          "title": "Unternehmenskarten-Authentifikator"
        },
        "fourth step": {
          "content": "Auf der rechten Seite sehen Sie das Fenster mit den Unternehmensdaten. Hier finden Sie alle Informationen zu dem angelegten Unternehmen.\n\nKlicken Sie auf <strong>„Weiter</strong>“, um fortzufahren.",
          "title": "Unternehmensdaten"
        },
        "second step": {
          "content": "Navigieren Sie über die linke Seitenleiste zur hervorgehobenen Seite <strong>„Unternehmen</strong>“.",
          "title": "Unternehmensseite"
        },
        "third step": {
          "content": "Um den Bildschirm mit den Unternehmenskarten anzuzeigen, müssen Sie zunächst auf eines der Unternehmen klicken.\n\nWählen Sie für dieses Tutorial das hervorgehobene Unternehmen aus, das sich oben in der Tabelle befindet.",
          "title": "Wählen Sie ein Unternehmen"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Um eine neue Firmenkarte hinzuzufügen, klicken Sie auf die hervorgehobene Schaltfläche „Neu hinzufügen“. Wenn der Bildschirm zum Hinzufügen einer Firma angezeigt wird, füllen Sie die erforderlichen Felder aus und klicken Sie zum Abschluss auf die Schaltfläche „Speichern“.\n\nHinweis: Die Firmenkarten-ID finden Sie im Firmenkarten-Authentifikator in der Spalte „Karten-ID“.\n\nKlicken Sie auf „Weiter“, um fortzufahren.",
          "title": "Neue Firmenkarte hinzufügen"
        },
        "final step": {
          "content": "Alle hinzugefügten Karten werden unter dem hervorgehobenen Punkt „Unternehmenskarten“ aufgelistet. Dort sehen Sie den Status der Karte, das Gültigkeitsdatum und die ID.\n\nHinweis: Sie können dieses Tutorial jederzeit wiederholen, indem Sie zu „Einstellungen“ – „Tutorials“ gehen. \n\nKlicken Sie auf <strong>„Fertigstellen</strong>“, um das Tutorial abzuschließen.",
          "title": "Angaben zur Firmenkarte"
        },
        "first step": {
          "content": "Zunächst müssen wir zur <strong>Seite</strong> <strong>„Unternehmen“</strong> navigieren, die sich im Menü oben rechts befindet.\n\nKlicken Sie auf den hervorgehobenen Bereich, um das <strong>Menü</strong> zu öffnen.",
          "title": "Menü öffnen"
        },
        "fourth step": {
          "content": "Hier finden Sie alle Informationen zum angelegten Unternehmen.\n\nKlicken Sie auf <strong>„Weiter</strong>“, um fortzufahren.",
          "title": "Unternehmensdaten"
        },
        "second step": {
          "content": "Um die <strong>Seite „Unternehmen“</strong> zu öffnen, klicken Sie auf den hervorgehobenen Bereich.",
          "title": "Unternehmensseite"
        },
        "third step": {
          "content": "Hier finden Sie eine Übersicht aller Unternehmen. Klicken Sie auf die hervorgehobene Schaltfläche, um den Bildschirm <strong>Unternehmensdetails</strong> zu öffnen.",
          "title": "Weitere Details"
        }
      },
      "name": "Firmenkarte hinzufügen"
    },
    "add vehicle": {
      "first step": {
        "content": "Um einen Zeitplan anzuwenden, muss mindestens ein Fahrzeug vorhanden sein. Klicken Sie auf die hervorgehobene Schaltfläche <strong>„Fahrzeug hinzufügen\"</strong>, füllen Sie alle erforderlichen Felder aus und bestätigen Sie mit „Hinzufügen\".",
        "title": "Es wurden keine Fahrzeuge hinzugefügt"
      },
      "name": "Fahrzeug hinzufügen"
    },
    "apply schedule": {
      "desktop": {
        "fifth step": {
          "content": "Sobald Sie einen Zeitplan ausgewählt haben, wird die Schaltfläche „<strong>Übernehmen</strong>\" aktiviert. Klicken Sie auf „<strong>Übernehmen</strong>\" und anschließend auf „<strong>Weiter</strong>\", um fortzufahren.",
          "title": "Wählen Sie einen Zeitplan aus, der angewendet werden soll"
        },
        "final step": {
          "content": "Sobald ein Zeitplan erfolgreich angewendet wurde, startet der Daten-Download zur geplanten Zeit. Alle einem Fahrzeug oder Fahrer zugewiesenen Zeitpläne werden im Bereich <strong>„Weitere Details\"</strong> angezeigt. Klicken Sie auf <strong>„Fertigstellen\"</strong>, um das Tutorial abzuschließen.",
          "title": "Zeitplan erfolgreich angewendet"
        },
        "first step": {
          "content": "Fahrzeugzeitpläne finden Sie auf der Seite „Fahrzeuge\", Fahrerzeitpläne auf der Seite „Fahrer\". Da der Vorgang auf beiden Seiten identisch ist, wählen Sie für dieses Tutorial die hervorgehobene Seite <strong>„Fahrzeuge\"</strong> aus.",
          "title": "Zeitplan für Fahrzeuge oder Fahrer"
        },
        "fourth step": {
          "content": "Klicken Sie auf einen Zeitplan, um ihn auf das/die ausgewählte(n) Fahrzeug(e) anzuwenden.\n\nKlicken Sie auf <strong>„Weiter</strong>“, um fortzufahren",
          "title": "Wählen Sie einen Zeitplan aus, der angewendet werden soll"
        },
        "second step": {
          "content": "Wählen Sie zunächst ein oder mehrere Fahrzeuge aus. Klicken Sie für dieses Tutorial auf die hervorgehobene Schaltfläche, um das <strong>erste Fahrzeug in der Tabelle</strong> auszuwählen.",
          "title": "Fahrzeug auswählen"
        },
        "third step": {
          "content": "Nachdem Sie nun ein Fahrzeug ausgewählt haben, wird die Schaltfläche „Zeitpläne“ aktiviert.\n\nKlicken Sie auf die hervorgehobene Schaltfläche <strong>„Zeitpläne</strong>“, um fortzufahren.",
          "title": "Offene Zeitpläne"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Nachdem Sie ein Fahrzeug ausgewählt haben, wird die Schaltfläche „Zeitpläne\" hervorgehoben. Klicken Sie auf „<strong>Zeitpläne</strong>\", um fortzufahren.",
          "title": "Offene Zeitpläne"
        },
        "final step": {
          "content": "Wenn ein Zeitplan erfolgreich auf ein Fahrzeug angewendet wurde, beginnt der Daten-Download gemäß der geplanten Zeit.\nAlle auf ein Fahrzeug oder einen Fahrer angewendeten Zeitpläne werden im hervorgehobenen Bereich „<strong>Weitere Details</strong>“ angezeigt.\n\nKlicken Sie auf <strong>„Fertigstellen</strong>“, um das Tutorial abzuschließen.",
          "title": "Zeitplan erfolgreich angewendet"
        },
        "first step": {
          "content": "Fahrzeugzeitpläne finden Sie auf der Seite „Fahrzeuge\", Fahrerzeitpläne auf der Seite „Fahrer\". Da der Vorgang auf beiden Seiten identisch ist, wählen Sie für dieses Tutorial die hervorgehobene <strong>Seite „Fahrzeuge\"</strong> aus.",
          "title": "Zeitplan für Fahrzeuge oder Fahrer"
        },
        "fourth step": {
          "content": "Wählen wir für dieses Tutorial das erste Fahrzeug in der Tabelle aus, indem wir auf die hervorgehobene Schaltfläche klicken.",
          "title": "Fahrzeug auswählen"
        },
        "second step": {
          "content": "Da der Vorgang auf beiden Seiten identisch ist, wählen wir für dieses Tutorial die hervorgehobene <strong>„Fahrzeuge\"</strong>-Seite aus.",
          "title": "Seite „Fahrzeuge“"
        },
        "seventh step": {
          "content": "Nachdem Sie einen Zeitplan ausgewählt haben, wird die hervorgehobene Schaltfläche „<strong>Übernehmen</strong>“ aktiv. Wenn Sie darauf klicken, wird der Zeitplan auf das ausgewählte Fahrzeug angewendet.\n\nKlicken Sie auf <strong>„Weiter</strong>“, um fortzufahren.",
          "title": "Wählen Sie einen Zeitplan aus, der angewendet werden soll"
        },
        "sixth step": {
          "content": "Nachdem Sie das Fahrzeug ausgewählt haben, können Sie einen Zeitplan auswählen, indem Sie darauf klicken.\n\nKlicken Sie auf <strong>„Weiter</strong>“, um fortzufahren",
          "title": "Wählen Sie einen Zeitplan aus, der angewendet werden soll"
        },
        "third step": {
          "content": "Sie müssen zunächst ein oder mehrere Fahrzeuge auswählen, bevor Sie einen Zeitplan auf diese anwenden können.\nKlicken Sie dazu zunächst auf die hervorgehobene Schaltfläche <strong>„Zeilen auswählen</strong>“.",
          "title": "Auswahltool öffnen"
        }
      },
      "name": "Zeitplan anwenden"
    },
    "company selector": {
      "desktop": {
        "first step": {
          "content": "Im oberen Menü können Sie über die Firmenauswahl die Firma auswählen, mit der Sie in TachoSync arbeiten möchten.\nDies ist erforderlich, wenn Sie mehr als eine Firma verwalten.\n\nKlicken Sie auf die <strong>hervorgehobene</strong> Schaltfläche, um die Firmenauswahl zu öffnen.",
          "title": "Unternehmensauswahl öffnen"
        },
        "second step": {
          "content": "Wählen Sie hier das Unternehmen aus, mit dem Sie arbeiten möchten. Alle anderen Bereiche zeigen nur Ressourcen dieses Unternehmens an. Die Auswahl wird beim Abmelden automatisch gespeichert.",
          "title": "Unternehmensauswahl"
        }
      },
      "mobile": {
        "first step": {
          "content": "Über die Firmenauswahl im oberen Menü legen Sie fest, mit welcher Firma Sie in TachoSync arbeiten möchten. Dies ist relevant, wenn Sie mehrere Firmen verwalten. Klicken Sie auf die <strong>hervorgehobene</strong> Schaltfläche, um die Firmenauswahl zu öffnen.",
          "title": "Unternehmensauswahl öffnen"
        },
        "second step": {
          "content": "Auf dem Unternehmensauswahlbildschirm wählen Sie das Unternehmen aus, mit dem Sie arbeiten möchten. In allen anderen Bereichen werden dann ausschließlich Ressourcen des ausgewählten Unternehmens angezeigt. Die Auswahl wird beim Abmelden automatisch gespeichert.",
          "title": "Unternehmensauswahl"
        }
      },
      "name": "Unternehmensauswahl"
    },
    "create schedule": {
      "desktop": {
        "fifth step": {
          "content": "Sobald ein Zeitplan erstellt wurde, muss er auf ausgewählte Fahrzeuge oder Fahrer angewendet werden. Im Tutorial <strong>„Zeitplan anwenden\"</strong> erfahren Sie, wie das funktioniert. Klicken Sie auf <strong>„Weiter\"</strong>, um fortzufahren.",
          "title": "Zeitplan nicht angewendet"
        },
        "final step": {
          "content": "Herzlichen Glückwunsch, Sie haben erfolgreich gelernt, wie man einen Zeitplan erstellt.\n\nAls Nächstes lernen Sie, wie Sie einen Zeitplan auf ausgewählte Elemente anwenden.\n\nKlicken Sie auf <strong>„Fertigstellen</strong>“, um das Tutorial abzuschließen.",
          "title": "Zeitplan erstellen – abgeschlossen"
        },
        "first step": {
          "content": "Ein Zeitplan automatisiert den Download von Tachographendaten Ihrer Fahrzeuge und Fahrer zu festgelegten Zeiten und Intervallen. Durch die Angabe von Startdatum, Uhrzeit und Häufigkeit (z. B. täglich) werden Daten zuverlässig und ohne manuellen Aufwand erfasst. Klicken Sie auf <strong>„Loslegen\"</strong>, um zu beginnen.",
          "title": "Was ist ein Zeitplan?"
        },
        "fourth step": {
          "content": "Hier können Sie Zeitpläne erstellen, bearbeiten, pausieren oder löschen. Der erste Eintrag ist stets für den globalen Zeitplan reserviert und kann nicht gelöscht werden.",
          "title": "Zeitpläne"
        },
        "second step": {
          "content": "Fahrzeugzeitpläne finden Sie auf der Seite „Fahrzeuge\", Fahrerzeitpläne auf der Seite „Fahrer\". Da der Vorgang auf beiden Seiten identisch ist, wählen wir für dieses Tutorial die hervorgehobene Seite <strong>„Fahrzeuge\"</strong> aus.",
          "title": "Zeitplan für Fahrzeuge oder Fahrer"
        },
        "third step": {
          "content": "Ein Zeitplan kann jederzeit im Fenster „Zeitpläne\" erstellt und bearbeitet werden, unabhängig davon, ob bereits Fahrzeuge oder Fahrer hinzugefügt wurden. Klicken Sie nun auf die hervorgehobene Schaltfläche <strong>„Zeitpläne\"</strong>, um fortzufahren.",
          "title": "Offene Zeitpläne"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Hier können Sie Zeitpläne erstellen, bearbeiten, pausieren oder löschen. Der erste Eintrag ist stets für den globalen Zeitplan reserviert und kann nicht gelöscht werden.",
          "title": "Zeitpläne"
        },
        "final step": {
          "content": "Herzlichen Glückwunsch, Sie haben erfolgreich gelernt, wie man einen Zeitplan erstellt.\n\nAls Nächstes lernen Sie, wie Sie einen Zeitplan auf ausgewählte Elemente anwenden.\n\nKlicken Sie auf <strong>„Fertigstellen</strong>“, um das Tutorial abzuschließen.",
          "title": "Zeitplan erstellen – abgeschlossen"
        },
        "first step": {
          "content": "Ein Zeitplan automatisiert den Download von Tachographendaten Ihrer Fahrzeuge und Fahrer zu festgelegten Zeiten und Intervallen. Durch die Angabe von Startdatum, Uhrzeit und Häufigkeit (z. B. täglich) werden Daten zuverlässig und ohne manuellen Aufwand erfasst. Klicken Sie auf <strong>„Loslegen\"</strong>, um zu beginnen.",
          "title": "Was ist ein Zeitplan?"
        },
        "fourth step": {
          "content": "Ein Zeitplan kann jederzeit im Fenster „Zeitpläne\" erstellt und bearbeitet werden, unabhängig davon, ob bereits Fahrzeuge oder Fahrer hinzugefügt wurden. Klicken Sie auf die hervorgehobene Schaltfläche <strong>„Zeitpläne\"</strong>, um fortzufahren.",
          "title": "Offene Zeitpläne"
        },
        "second step": {
          "content": "Fahrzeugzeitpläne finden Sie auf der Seite „Fahrzeuge\", Fahrerzeitpläne auf der Seite „Fahrer\". Um dorthin zu gelangen, öffnen wir zunächst das <strong>Menü</strong>.",
          "title": "Zeitplan für Fahrzeuge oder Fahrer"
        },
        "sixth step": {
          "content": "Sobald ein Zeitplan erstellt wurde, muss er auf ausgewählte Fahrzeuge oder Fahrer angewendet werden. Wie das funktioniert, wird im Tutorial <strong>„Zeitplan anwenden\"</strong> erklärt. Klicken Sie auf <strong>„Weiter\"</strong>, um fortzufahren.",
          "title": "Zeitplan nicht angewendet"
        },
        "third step": {
          "content": "Da der Vorgang auf beiden Seiten ähnlich ist, wählen wir für dieses Tutorial die hervorgehobene <strong>„Fahrzeugseite“</strong> aus.",
          "title": "Seite „Fahrzeuge“"
        }
      },
      "name": "Zeitplan erstellen"
    }
  }
}
